import { media, remCalc } from "./style-utils-coras-nua";
import { createGlobalStyle } from "styled-components";
import solasTokens from "@boi/design-tokens/dist/web/boi/light/tokens.json";

const GlobalStyle = createGlobalStyle`
    * {
        font-family: ${props => props.theme.fonts.fontFamily}, "san-serif";
    }
    @media print {
        .u-hide-for-print{
            display: none;
            }
        .formContent{
            width: 100%;
        }
    }
    .formContent .thankYouPage button{
        width: 70%;
        margin: 0 auto .5rem auto;
        ${media.sm.down`
            width: 100%;
        `}
    }
    html, body, #root, .App{
        height: 100%;
    }
    body {
        background: ${solasTokens.themeColor.base150};
        ${media.md.down`
            background: ${solasTokens.themeColor.base150};
        `}
        margin: 0;
        padding: 0;
        ${media.sm.down`
            height: 100vh;
        `}
        .cx-widget.cx-theme-boi{
            ${media.sm.down`
                z-index: 5 !important;
            `}
        }
    }
    .App{
        position: relative;
        min-height: 100vh;
        min-height: -webkit-fill-available;
    }
    .App,
    .field:not(.section) {
        display: flex;
        flex-direction: column;
    }
    form{
        ${"" /* background: ${props => props.theme.colors.brilliant}; */}
    }
    form{
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        .controls {
            display: flex;
            flex-direction: column;
            position: relative;
            &.inline-field-support{
                flex-direction: row;
                flex-wrap: wrap;
                align-content: flex-start;

                > *{
                    flex-basis: 100%;
                    max-width: 100%;
                }
                > .fifty, > .u-display-inline-50{
                    flex-basis: calc(50% - 8px);
                    &.product-display-block{
                        flex-basis: calc(50% - ${remCalc(48)});
                        padding: ${remCalc(16)};
                        margin-bottom: ${props => props.theme.space[6]};
                    }
                    &.left{
                        margin-right: auto;
                    }
                    &.right{
                        margin-left: auto;
                    }
                    &.u-display-stack-sm{
                        ${media.sm.down`
                            flex-basis: 100%;
                        `}
                    }
                }
                &.wider-display{
                    ${media.md.up`
                        margin-left: ${remCalc(-94)};
                        margin-right: ${remCalc(-94)};
                        > .fifty, > .u-display-inline-50{
                            flex-basis: calc(50% - 25px);
                            &.product-display-block{
                                flex-basis: calc(50% - 60px);
                            }
                        }
                    `}
                }

                .react-aria-TextField {
                    margin-left: 0 !important;
                }
            }
            &.hide-next.hide-back .block div button{
                width: 100%;
            }
            &.hide-next.hide-back .block button{
                margin-top: .5rem;
            }
        }
        .form-navigation{
            &.wider-display{
                ${media.md.up`
                    margin-left: ${remCalc(-94)};
                    margin-right: ${remCalc(-94)};
                `}
                &.block{
                    margin-left: auto;
                    margin-right: auto;
                }
            }
            ${media.sm.down`
                flex-direction: column-reverse;
                button {
                    width: 100%;
                    margin-bottom: ${solasTokens.spacing.s8};
                }
            `}
        }
    }


    hr{
        margin: ${remCalc(24)} 0;
        border: none;
        border-top: ${remCalc(1)} solid ${props =>
    props.theme.colors.monotoneMid};
        .u-hr-reduced &{
            margin: ${remCalc(12)} 0;
        }
    }
    a{
        color: ${props => props.theme.colors.primary};
        font-weight: ${props => props.theme.fontWeights.semiBold};
        text-decoration: underline;
        &:hover{
            color: ${props => props.theme.colors.primaryTone};
        }
        &[target="_blank"]:not([href^="tel:"]):not(.no-after){
            &:after{
                width: ${remCalc(12)};
                height: ${remCalc(12)};
                content: ' ';
                margin-left: ${remCalc(4)};
                background-image: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg  viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3Ee%3C/title%3E %3Cg id='Templates' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M5.0824769,12.0015612 C5.16844471,12.0015612 5.28743246,11.9521533 5.34810126,11.8912404 L13.8543371,3.38469938 L15.3608948,4.89095189 C15.421411,4.95097983 15.5397274,4.99968577 15.6249627,4.99968577 C15.8317799,4.99968577 15.9997787,4.83183949 15.9999619,4.62502235 L15.9999619,0.375032485 C15.9999619,0.168032246 15.831963,3.33786011e-05 15.6249627,3.33786011e-05 L11.3749729,3.33786011e-05 C11.1681557,0.000216483633 11.0003095,0.168215351 11.0003095,0.375032485 C11.0003095,0.460695122 11.0494427,0.579408218 11.1099589,0.640046501 L12.6159062,2.14660419 L4.10967038,10.6528095 C4.04878795,10.7134783 3.99938011,10.8324966 3.99938011,10.9184339 C3.99938011,11.0044017 4.04878795,11.1233894 4.10967038,11.1840582 L4.81685253,11.8912404 C4.87752133,11.9521533 4.9965396,12.0015612 5.0824769,12.0015612 Z M12.4999702,15.9999952 C13.3279712,15.9999952 13.9999666,15.3279998 13.9999666,14.4999988 L13.9999666,9.50001073 C13.9999666,9.22401041 13.7759681,9.00001192 13.4999678,9.00001192 L12.999969,9.00001192 C12.7239687,9.00001192 12.4999702,9.22401041 12.4999702,9.50001073 L12.4999702,14.3124993 C12.4999702,14.4159841 12.4159555,14.4999988 12.3124706,14.4999988 L1.68749598,14.4999988 C1.58401112,14.4999988 1.5,14.4159841 1.5,14.3124993 L1.5,3.68752459 C1.5,3.58403973 1.58401112,3.50002861 1.68749598,3.50002861 L6.4999845,3.50002861 C6.77598482,3.50002861 6.99998331,3.27602654 6.99998331,3.00002861 L6.99998331,2.50002861 C6.99998331,2.2240271 6.77598482,2.00002861 6.4999845,2.00002861 L1.5,2.00002861 C0.671995468,2.00002861 0,2.67202408 0,3.50002861 L0,14.4999988 C0,15.3279998 0.671995468,15.9999952 1.5,15.9999952 L12.4999702,15.9999952 Z' id='e' fill='%230000ff' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                display: inline-block;
                margin-bottom: ${remCalc(0.5)};
            }
            &:hover{
                &:after{
                    background-image: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg  viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3Ee%3C/title%3E %3Cg id='Templates' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M5.0824769,12.0015612 C5.16844471,12.0015612 5.28743246,11.9521533 5.34810126,11.8912404 L13.8543371,3.38469938 L15.3608948,4.89095189 C15.421411,4.95097983 15.5397274,4.99968577 15.6249627,4.99968577 C15.8317799,4.99968577 15.9997787,4.83183949 15.9999619,4.62502235 L15.9999619,0.375032485 C15.9999619,0.168032246 15.831963,3.33786011e-05 15.6249627,3.33786011e-05 L11.3749729,3.33786011e-05 C11.1681557,0.000216483633 11.0003095,0.168215351 11.0003095,0.375032485 C11.0003095,0.460695122 11.0494427,0.579408218 11.1099589,0.640046501 L12.6159062,2.14660419 L4.10967038,10.6528095 C4.04878795,10.7134783 3.99938011,10.8324966 3.99938011,10.9184339 C3.99938011,11.0044017 4.04878795,11.1233894 4.10967038,11.1840582 L4.81685253,11.8912404 C4.87752133,11.9521533 4.9965396,12.0015612 5.0824769,12.0015612 Z M12.4999702,15.9999952 C13.3279712,15.9999952 13.9999666,15.3279998 13.9999666,14.4999988 L13.9999666,9.50001073 C13.9999666,9.22401041 13.7759681,9.00001192 13.4999678,9.00001192 L12.999969,9.00001192 C12.7239687,9.00001192 12.4999702,9.22401041 12.4999702,9.50001073 L12.4999702,14.3124993 C12.4999702,14.4159841 12.4159555,14.4999988 12.3124706,14.4999988 L1.68749598,14.4999988 C1.58401112,14.4999988 1.5,14.4159841 1.5,14.3124993 L1.5,3.68752459 C1.5,3.58403973 1.58401112,3.50002861 1.68749598,3.50002861 L6.4999845,3.50002861 C6.77598482,3.50002861 6.99998331,3.27602654 6.99998331,3.00002861 L6.99998331,2.50002861 C6.99998331,2.2240271 6.77598482,2.00002861 6.4999845,2.00002861 L1.5,2.00002861 C0.671995468,2.00002861 0,2.67202408 0,3.50002861 L0,14.4999988 C0,15.3279998 0.671995468,15.9999952 1.5,15.9999952 L12.4999702,15.9999952 Z' id='e' fill='%23000066' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                }
            }
        }
        &[href^="tel:"] {
            padding-right: 0;
            margin-right: 0;
            background-image: none;
        }
    }
    .u-icon-divider-2rem{
        hr{
            margin-top: -2rem;
        }
        img{
            display: flex;
            margin: auto;
        }
    }
    .u-title-decorator > div, .section.u-title-decorator{
        > h2, > h3{
            margin-bottom: ${props => props.theme.space[4]};
            &:after{
                background-color: ${props => props.theme.colors.primary};
                content: "";
                display: block;
                height: ${props => props.theme.space[1]};
                margin-top: ${props => props.theme.space[1]};
                width: ${props => props.theme.space[6]};;
            }
        }
    }
    .section.u-title-decorator{
        > h2, > h3{
            margin-bottom: ${props => props.theme.space[6]};
        }
    }

    .u-width-html-p-60px &{
        div{
            p{
                width: ${remCalc(60)};
                max-width: ${remCalc(60)};
                min-width: ${remCalc(60)};
                margin-left: ${remCalc(12)};
            }
        }
    }
    .u-width-html-p-120px &{
        div{
            p{
                width: ${remCalc(120)};
                max-width: ${remCalc(120)};
                min-width: ${remCalc(120)};
                margin-left: ${remCalc(12)};
            }
        }
    }
    .u-width-html-p-60px, .u-width-html-p-120px{
        div{
            p{
                transition: all ease-in-out 0.3s;
            }
        }
    }
    ${media.sm.down`
        .u-width-html-p-sm-60px &{
            div{
                p{
                    width: 60px;
                    max-width: 60px;
                    min-width: 60px;
                    margin-left: 12px;
                }
            }
        }
        .u-width-html-p-sm-120px &{
            div{
                p{
                    width: 120px;
                    max-width: 120px;
                    min-width: 120px;
                    margin-left: 12px;
                }
            }
        }
        .u-width-html-p-sm-60px, .u-width-html-p-sm-120px{
            div{
                p{
                    transition: all ease-in-out 0.3s;
                }
            }
        }
    `}
    ${media.xs.down`
        .u-width-html-p-xs-60px &{
            div{
                p{
                    width: 60px;
                    max-width: 60px;
                    min-width: 60px;
                    margin-left: 12px;
                }
            }

        }
        .u-width-html-p-xs-120px &{
            div{
                p{
                    width: 120px;
                    max-width: 120px;
                    min-width: 120px;
                    margin-left: 12px;
                }
            }

        }
        .u-width-html-p-xs-60px, .u-width-html-p-xs-120px{
            div{
                p{
                    transition: all ease-in-out 0.3s;
                }
            }
        }
    `}
    .u-display-block{
        display: block;
    }
    .u-display-flex{
        display: flex;
    }
    .u-display-flex-html{
        div{
            display: flex;
        }
    }
    .u-justify-flex-end-html{
        div{
            justify-content: flex-end;
        }
    }
    .u-flex-direction-column{
        flex-direction: column;
    }
    ${media.xxs.down`
        .u-flex-direction-column-xxs{
            flex-direction: column;
        }
    `}
    .u-flex-grow{
        flex-grow: 1;
    }
    ${media.sm.down`
        .u-flex-grow-sm{
            flex-grow: 1;
        }
    `}
    .u-position-absolute{
        position: absolute;
    }
    .u-position-fixed{
        position: fixed;
    }
    .u-position-relative{
        position: relative;
    }
    .u-position-static{
        position: static;
    }
    .u-text-no-underline{
        text-decoration: none;
    }
    ${media.xxs.down`
        .u-position-xxs-absolute{
            position: absolute;
        }
        .u-position-xxs-fixed{
            position: fixed;
        }
        .u-position-xxs-relative{
            position: relative;
        }
        .u-position-xxs-static{
            position: static;
        }
    `}
    .u-z-index-1{
        z-index: 1;
    }
    .u-z-index-2{
        z-index: 2;
    }
    .u-z-index-3{
        z-index: 3;
    }
    .u-z-index-4{
        z-index: 4;
    }
    ${media.sm.down`
        .u-z-index-sm-1{
            z-index: 1;
        }
        .u-z-index-sm-2{
            z-index: 2;
        }
        .u-z-index-sm-3{
            z-index: 3;
        }
        .u-z-index-sm-4{
            z-index: 4;
        }
    `}
    .u-bottom-0{
        bottom: 0 !important;
    }
    .u-bottom-16{
        bottom: ${remCalc(16)} !important;
    }

    .u-width-100{
        width: 100% !important;
    }
    .u-width-70{
        width: 70% !important;
    }
    .u-width-80{
        width: 80% !important;
    }
    .u-width-50{
        width: 50% !important;
    }
    .u-width-40{
        width: 40% !important;
    }
    .u-width-30{
        width: 30% !important;
    }
    .u-width-100px{
        width: ${remCalc(100)} !important;
    }
    .u-width-70px{
        width: ${remCalc(70)} !important;
    }
    .u-width-80px{
        width: ${remCalc(80)} !important;
    }
    .u-width-50px{
        width: ${remCalc(50)} !important;
    }
    ${media.sm.down`
        .u-width-sm-100{
            width: 100% !important;
        }
        .u-width-sm-70{
            width: 70% !important;
        }
        .u-width-sm-80{
            width: 80% !important;
        }
        .u-width-sm-50{
            width: 50% !important;
        }
        .u-width-sm-40{
            width: 40% !important;
        }
        .u-width-sm-30{
            width: 30% !important;
        }
    `}
    ${media.xs.down`
        .u-width-xs-100{
            width: 100% !important;
        }
        .u-width-xs-70{
            width: 70% !important;
        }
        .u-width-xs-80{
            width: 80% !important;
        }
        .u-width-xs-60{
            width: 60% !important;
        }
        .u-width-xs-50{
            width: 50% !important;
        }
        .u-width-xs-40{
            width: 40% !important;
        }
        .u-width-xs-30{
            width: 30% !important;
        }
    `}
    ${media.xxs.down`
        .u-width-xxs-100{
            width: 100% !important;
        }
        .u-width-xxs-70{
            width: 70% !important;
        }
        .u-width-xxs-80{
            width: 80% !important;
        }
        .u-width-xxs-60{
            width: 60% !important;
        }
        .u-width-xxs-50{
            width: 50% !important;
        }
        .u-width-xxs-40{
            width: 40% !important;
        }
        .u-width-xxs-30{
            width: 30% !important;
        }
        .u-width-xxs-auto{
            width: auto !important;
        }
    `}
    .u-width-60px{
        width: 60px !important;
    }
    .u-width-auto{
        width: auto !important;
    }
    .u-left-0{
        left: 0;
    }
    .u-left-10{
        left: 10%;
    }
    .u-right-10{
        right: 10%;
    }
    ${media.sm.down`
        .u-left-sm-0{
            left: 0 !important;
        }
        .u-left-sm-10{
            left: 10% !important;
        }
        .u-right-sm-10{
            right: 10% !important;
        }
    `}
    ul{
        list-style-type: disc;
    }
    ol, ul{
        color: ${props => props.theme.colors.monotoneDark};
        font-size: ${props => props.theme.fontSizes[2]};
        padding-left: ${props => props.theme.space[6]};
        margin-top: 0;
        padding-top: 0;
        > li {
            padding: 0 ${props => props.theme.space[2]} ${props =>
    props.theme.space[2]} ${props => props.theme.space[2]};
            *:last-child{
                margin-bottom: 0;
            }

        }
    }
    .u-list-indented{
        ol, ul{
            margin-left: ${props => props.theme.space[3]};
            ol, ul{
                margin-left: 0;
            }
        }
    }
    .sticky {
        position: fixed;
        z-index: 1000;
    }
    .line-break{
        white-space: pre-line;
    }
    .overflow-ellipsis{
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .title-line-break{
        h1{
            white-space: pre-line;
        }
    }
    .title-overflow-ellipsis{
        h1{
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .hide-xs-up{
        ${media.xs.up`
            display: none !important;
        `}
    }
    .hide-xs-only{
        ${media.xs.only`
            display: none !important;
        `}
    }
    .hide-xs-down{
        ${media.sm.down`
            display: none !important;
        `}
    }
    ${"" /* Hide Responsive classes */}
    .hide-sm-up{
        ${media.sm.up`
            display: none !important;
        `}
    }
    .hide-sm-only{
        ${media.sm.only`
            display: none !important;
        `}
    }
    .hide-sm-down{
        ${media.sm.down`
            display: none !important;
        `}
    }
    .hide-md-up{
        ${media.md.up`
            display: none !important;
        `}
    }
    .hide-md-only{
        ${media.md.only`
            display: none !important;
        `}
    }
    .hide-md-down{
        ${media.md.down`
            display: none !important;
        `}
    }
    .hide-lg-up{
        ${media.lg.up`
            display: none !important;
        `}
    }
    .hide-lg-only{
        ${media.lg.only`
            display: none !important;
        `}
    }
    .hide-lg-down{
        ${media.lg.down`
            display: none !important;
        `}
    }
    .hide-xl-up{
        ${media.xl.up`
            display: none !important;
        `}
    }
    .hide-xl-only{
        ${media.xl.only`
            display: none !important;
        `}
    }
    .hide-xl-down{
        ${media.xl.down`
            display: none !important;
        `}
    }

    /* Button style on links - utility classes */
    a.u-button-primary{
        border-radius: ${props => props.theme.radius};
        font-size: ${remCalc(16)};
        font-weight: ${props => props.theme.fontWeights.semiBold};
        display: flex;
        margin-right: 0;
        padding-left: ${props => props.theme.space[4]};
        padding-right: ${props => props.theme.space[4]};
        height: 60px;
        text-decoration: none;
        align-items: center;
        justify-content: center;
        background: ${props => props.theme.colors.primary};
        border-color: ${props => props.theme.colors.primary};
        color: ${props => props.theme.colors.brilliant};
    }
    a.u-button-secondary{
        border-radius: ${props => props.theme.radius};
        font-size: ${remCalc(16)};
        font-weight: ${props => props.theme.fontWeights.semiBold};
        height: 60px;
        align-items: center;
        justify-content: center;
        display: flex;
        text-decoration: none;
        margin-right: 0;
        padding-left: ${props => props.theme.space[4]};
        padding-right: ${props => props.theme.space[4]};
        background: none;
        border-color: ${props => props.theme.colors.primary};
        color: ${props => props.theme.colors.primary};
    }

    ${"" /* Alignment Responsive classes */}
    .u-text-centre{
        text-align: center !important;
    }
    .u-text-right{
        text-align: right !important;
    }
    .u-text-left{
        text-align: left !important;
    }
    .u-text-justify{
        text-align: justify !important;
    }
    
    ${media.sm.only`
        .u-text-sm-centre {
            text-align: center !important;
        }
        .u-text-sm-right{
            text-align: right !important;
        }
        .u-text-sm-left{
            text-align: left !important;
        }
        .u-text-sm-justify{
            text-align: justify !important;
        }
    `}
    ${media.md.only`
        .u-text-md-centre {
            text-align: center !important;
        }
        .u-text-md-right{
            text-align: right !important;
        }
        .u-text-md-left{
            text-align: left !important;
        }
        .u-text-md-justify{
            text-align: justify !important;
        }
    `}
    ${media.lg.only`
        .u-text-lg-centre {
            text-align: center !important;
        }
        .u-text-lg-right{
            text-align: right !important;
        }
        .u-text-lg-left{
            text-align: left !important;
        }
        .u-text-lg-justify{
            text-align: justify !important;
        }
    `}
    ${media.xl.only`
        .u-text-xl-centre {
            text-align: center !important;
        }
        .u-text-xl-right{
            text-align: right !important;
        }
        .u-text-xl-left{
            text-align: left !important;
        }
        .u-text-xl-justify{
            text-align: justify !important;
        }
    `}
    .u-list-align-left{
        ul, ol, li{
            text-align: left !important;
        }
        
    }
    ${
        ""
        /* Spacing responsive classes

    The classes are named using the format u-{property}{sides}-{size} for all devices and u-{property}{sides}-{breakpoint}-{size} for sm, md, lg, and xl.

    Where property is one of:
    m - for classes that set margin
    p - for classes that set padding

    Where sides is one of:
    t - for classes that set margin-top or padding-top
    b - for classes that set margin-bottom or padding-bottom
    l - for classes that set margin-left or padding-left
    r - for classes that set margin-right or padding-right
    x - for classes that set both *-left and *-right
    y - for classes that set both *-top and *-bottom
    blank - for classes that set a margin or padding on all 4 sides of the element

    Where size is one of:
    0 - for classes that eliminate the margin or padding by setting it to 0
    1 - (by default) for classes that set the margin or padding to $spacer-x * .25 or $spacer-y * .25
    2 - (by default) for classes that set the margin or padding to $spacer-x * .5 or $spacer-y * .5
    3 - (by default) for classes that set the margin or padding to $spacer-x or $spacer-y
    4 - (by default) for classes that set the margin or padding to $spacer-x * 1.5 or $spacer-y * 1.5
    5 - (by default) for classes that set the margin or padding to $spacer-x * 3 or $spacer-y * 3 */
    }

    .u-m-0 {
    margin: 0 0 !important;
    }

    .u-mt-0 {
    margin-top: 0 !important;
    }

    .u-mr-0 {
    margin-right: 0 !important;
    }

    .u-mb-0 {
    margin-bottom: 0 !important;
    }

    .u-ml-0 {
    margin-left: 0 !important;
    }

    .u-mx-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
    }

    .u-my-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    }

    .u-m-1 {
    margin: ${props => props.theme.space[1]} ${props =>
    props.theme.space[1]} !important;
    }

    .u-mt-1 {
    margin-top: ${props => props.theme.space[1]} !important;
    }

    .u-mr-1 {
    margin-right: ${props => props.theme.space[1]} !important;
    }

    .u-mb-1 {
    margin-bottom: ${props => props.theme.space[1]} !important;
    }

    .u-ml-1 {
    margin-left: ${props => props.theme.space[1]} !important;
    }

    .u-mx-1 {
    margin-right: ${props => props.theme.space[1]} !important;
    margin-left: ${props => props.theme.space[1]} !important;
    }

    .u-my-1 {
    margin-top: ${props => props.theme.space[1]} !important;
    margin-bottom: ${props => props.theme.space[1]} !important;
    }

    .u-m-2 {
    margin: ${props => props.theme.space[2]} ${props =>
    props.theme.space[2]} !important;
    }

    .u-mt-2 {
    margin-top: ${props => props.theme.space[2]} !important;
    }

    .u-mr-2 {
    margin-right: ${props => props.theme.space[2]} !important;
    }

    .u-mb-2 {
    margin-bottom: ${props => props.theme.space[2]} !important;
    }

    .u-ml-2 {
    margin-left: ${props => props.theme.space[2]} !important;
    }

    .u-mx-2 {
    margin-right: ${props => props.theme.space[2]} !important;
    margin-left: ${props => props.theme.space[2]} !important;
    }

    .u-my-2 {
    margin-top: ${props => props.theme.space[2]} !important;
    margin-bottom: ${props => props.theme.space[2]} !important;
    }

    .u-m-3 {
    margin: ${props => props.theme.space[3]} ${props =>
    props.theme.space[3]} !important;
    }

    .u-mt-3 {
    margin-top: ${props => props.theme.space[3]} !important;
    }

    .u-mr-3 {
    margin-right: ${props => props.theme.space[3]} !important;
    }

    .u-mb-3 {
    margin-bottom: ${props => props.theme.space[3]} !important;
    }

    .u-ml-3 {
    margin-left: ${props => props.theme.space[3]} !important;
    }

    .u-mx-3 {
    margin-right: ${props => props.theme.space[3]} !important;
    margin-left: ${props => props.theme.space[3]} !important;
    }

    .u-my-3 {
    margin-top: ${props => props.theme.space[3]} !important;
    margin-bottom: ${props => props.theme.space[3]} !important;
    }

    .u-m-4 {
    margin: ${props => props.theme.space[4]} ${props =>
    props.theme.space[4]} !important;
    }

    .u-mt-4 {
    margin-top: ${props => props.theme.space[4]} !important;
    }

    .u-mr-4 {
    margin-right: ${props => props.theme.space[4]} !important;
    }

    .u-mb-4 {
    margin-bottom: ${props => props.theme.space[4]} !important;
    }

    .u-ml-4 {
    margin-left: ${props => props.theme.space[4]} !important;
    }

    .u-mx-4 {
    margin-right: ${props => props.theme.space[4]} !important;
    margin-left: ${props => props.theme.space[4]} !important;
    }

    .u-my-4 {
    margin-top: ${props => props.theme.space[4]} !important;
    margin-bottom: ${props => props.theme.space[4]} !important;
    }

    .u-m-5 {
    margin: ${props => props.theme.space[5]} ${props =>
    props.theme.space[5]} !important;
    }

    .u-mt-5 {
    margin-top: ${props => props.theme.space[5]} !important;
    }

    .u-mr-5 {
    margin-right: ${props => props.theme.space[5]} !important;
    }

    .u-mb-5 {
    margin-bottom: ${props => props.theme.space[5]} !important;
    }

    .u-ml-5 {
    margin-left: ${props => props.theme.space[5]} !important;
    }

    .u-mx-5 {
    margin-right: ${props => props.theme.space[5]} !important;
    margin-left: ${props => props.theme.space[5]} !important;
    }

    .u-my-5 {
    margin-top: ${props => props.theme.space[5]} !important;
    margin-bottom: ${props => props.theme.space[5]} !important;
    }
    .u-m-6 {
    margin: ${props => props.theme.space[6]} ${props =>
    props.theme.space[6]} !important;
    }

    .u-mt-6 {
    margin-top: ${props => props.theme.space[6]} !important;
    }

    .u-mr-6 {
    margin-right: ${props => props.theme.space[6]} !important;
    }

    .u-mb-6 {
    margin-bottom: ${props => props.theme.space[6]} !important;
    }

    .u-ml-6 {
    margin-left: ${props => props.theme.space[6]} !important;
    }

    .u-mx-6 {
    margin-right: ${props => props.theme.space[6]} !important;
    margin-left: ${props => props.theme.space[6]} !important;
    }

    .u-my-6 {
    margin-top: ${props => props.theme.space[6]} !important;
    margin-bottom: ${props => props.theme.space[6]} !important;
    }
    ${"" /* TODO: Add more utilities from 6 - 16 */}
    .u-mt-17 {
        margin-top: ${props => props.theme.space[17]} !important;
    }
    .u-mb-17 {
        margin-bottom: ${props => props.theme.space[17]} !important;
    }
    .u-mx-17 {
        margin-right: ${props => props.theme.space[17]} !important;
        margin-left: ${props => props.theme.space[17]} !important;
    }
    .u-my-17 {
        margin-top: ${props => props.theme.space[17]} !important;
        margin-bottom: ${props => props.theme.space[17]} !important;
    }

    .u-mt-minus-1{
        margin-top: -${props => props.theme.space[1]} !important;
    }
    .u-mt-minus-2{
        margin-top: -${props => props.theme.space[2]} !important;
    }
    .u-mt-minus-3{
        margin-top: -${props => props.theme.space[3]} !important;
    }
    .u-mt-minus-4{
        margin-top: -${props => props.theme.space[4]} !important;
    }
    .u-mt-minus-5{
        margin-top: -${props => props.theme.space[5]} !important;
    }
    .u-mt-minus-6{
        margin-top: -${props => props.theme.space[6]} !important;
    }
    .u-mt-minus-12{
        margin-top: -${props => props.theme.space[12]} !important;
    }
    .u-mb-minus-1{
        margin-bottom: -${props => props.theme.space[1]} !important;
    }
    .u-mb-minus-2{
        margin-bottom: -${props => props.theme.space[2]} !important;
    }
    .u-mb-minus-3{
        margin-bottom: -${props => props.theme.space[3]} !important;
    }
    .u-mb-minus-4{
        margin-bottom: -${props => props.theme.space[4]} !important;
    }
    .u-mb-minus-5{
        margin-bottom: -${props => props.theme.space[5]} !important;
    }
    .u-mb-minus-6{
        margin-bottom: -${props => props.theme.space[6]} !important;
    }
    .u-ml-minus-1{
        margin-left: -${props => props.theme.space[1]} !important;
    }
    .u-ml-minus-2{
        margin-left: -${props => props.theme.space[2]} !important;
    }
    .u-ml-minus-3{
        margin-left: -${props => props.theme.space[3]} !important;
    }
    .u-ml-minus-4{
        margin-left: -${props => props.theme.space[4]} !important;
    }
    .u-ml-minus-5{
        margin-left: -${props => props.theme.space[5]} !important;
    }
    .u-ml-minus-6{
        margin-left: -${props => props.theme.space[6]} !important;
    }
    .u-mr-minus-1{
        margin-right: -${props => props.theme.space[1]} !important;
    }
    .u-mr-minus-2{
        margin-right: -${props => props.theme.space[2]} !important;
    }
    .u-mr-minus-3{
        margin-right: -${props => props.theme.space[3]} !important;
    }
    .u-mr-minus-4{
        margin-right: -${props => props.theme.space[4]} !important;
    }
    .u-mr-minus-5{
        margin-right: -${props => props.theme.space[5]} !important;
    }
    .u-mr-minus-6{
        margin-right: -${props => props.theme.space[6]} !important;
    }
    ${media.sm.down`
        .u-mt-sm-minus-1{
            margin-top: -${props => props.theme.space[1]} !important;
        }
        .u-mt-sm-minus-2{
            margin-top: -${props => props.theme.space[2]} !important;
        }
        .u-mt-sm-minus-3{
            margin-top: -${props => props.theme.space[3]} !important;
        }
        .u-mt-sm-minus-4{
            margin-top: -${props => props.theme.space[4]} !important;
        }
        .u-mt-sm-minus-5{
            margin-top: -${props => props.theme.space[5]} !important;
        }
        .u-mt-sm-minus-6{
            margin-top: -${props => props.theme.space[6]} !important;
        }
        .u-mb-sm-minus-1{
            margin-bottom: -${props => props.theme.space[1]} !important;
        }
        .u-mb-sm-minus-2{
            margin-bottom: -${props => props.theme.space[2]} !important;
        }
        .u-mb-sm-minus-3{
            margin-bottom: -${props => props.theme.space[3]} !important;
        }
        .u-mb-sm-minus-4{
            margin-bottom: -${props => props.theme.space[4]} !important;
        }
        .u-mb-sm-minus-5{
            margin-bottom: -${props => props.theme.space[5]} !important;
        }
        .u-mb-sm-minus-6{
            margin-bottom: -${props => props.theme.space[6]} !important;
        }
        .u-ml-sm-minus-1{
            margin-left: -${props => props.theme.space[1]} !important;
        }
        .u-ml-sm-minus-2{
            margin-left: -${props => props.theme.space[2]} !important;
        }
        .u-ml-sm-minus-3{
            margin-left: -${props => props.theme.space[3]} !important;
        }
        .u-ml-sm-minus-4{
            margin-left: -${props => props.theme.space[4]} !important;
        }
        .u-ml-sm-minus-5{
            margin-left: -${props => props.theme.space[5]} !important;
        }
        .u-ml-sm-minus-6{
            margin-left: -${props => props.theme.space[6]} !important;
        }
        .u-mr-sm-minus-1{
            margin-right: -${props => props.theme.space[1]} !important;
        }
        .u-mr-sm-minus-2{
            margin-right: -${props => props.theme.space[2]} !important;
        }
        .u-mr-sm-minus-3{
            margin-right: -${props => props.theme.space[3]} !important;
        }
        .u-mr-sm-minus-4{
            margin-right: -${props => props.theme.space[4]} !important;
        }
        .u-mr-sm-minus-5{
            margin-right: -${props => props.theme.space[5]} !important;
        }
        .u-mr-sm-minus-6{
            margin-right: -${props => props.theme.space[6]} !important;
        }
    `}
    ${media.md.up`
        .u-mt-md-minus-1{
            margin-top: -${props => props.theme.space[1]} !important;
        }
        .u-mt-md-minus-2{
            margin-top: -${props => props.theme.space[2]} !important;
        }
        .u-mt-md-minus-3{
            margin-top: -${props => props.theme.space[3]} !important;
        }
        .u-mt-md-minus-4{
            margin-top: -${props => props.theme.space[4]} !important;
        }
        .u-mt-md-minus-5{
            margin-top: -${props => props.theme.space[5]} !important;
        }
        .u-mt-md-minus-6{
            margin-top: -${props => props.theme.space[6]} !important;
        }
        .u-mb-md-minus-1{
            margin-bottom: -${props => props.theme.space[1]} !important;
        }
        .u-mb-md-minus-2{
            margin-bottom: -${props => props.theme.space[2]} !important;
        }
        .u-mb-md-minus-3{
            margin-bottom: -${props => props.theme.space[3]} !important;
        }
        .u-mb-md-minus-4{
            margin-bottom: -${props => props.theme.space[4]} !important;
        }
        .u-mb-md-minus-5{
            margin-bottom: -${props => props.theme.space[5]} !important;
        }
        .u-mb-md-minus-6{
            margin-bottom: -${props => props.theme.space[6]} !important;
        }
        .u-ml-md-minus-1{
            margin-left: -${props => props.theme.space[1]} !important;
        }
        .u-ml-md-minus-2{
            margin-left: -${props => props.theme.space[2]} !important;
        }
        .u-ml-md-minus-3{
            margin-left: -${props => props.theme.space[3]} !important;
        }
        .u-ml-md-minus-4{
            margin-left: -${props => props.theme.space[4]} !important;
        }
        .u-ml-md-minus-5{
            margin-left: -${props => props.theme.space[5]} !important;
        }
        .u-ml-md-minus-6{
            margin-left: -${props => props.theme.space[6]} !important;
        }
        .u-mr-md-minus-1{
            margin-right: -${props => props.theme.space[1]} !important;
        }
        .u-mr-md-minus-2{
            margin-right: -${props => props.theme.space[2]} !important;
        }
        .u-mr-md-minus-3{
            margin-right: -${props => props.theme.space[3]} !important;
        }
        .u-mr-md-minus-4{
            margin-right: -${props => props.theme.space[4]} !important;
        }
        .u-mr-md-minus-5{
            margin-right: -${props => props.theme.space[5]} !important;
        }
        .u-mr-md-minus-6{
            margin-right: -${props => props.theme.space[6]} !important;
        }
    `}
    ${media.lg.up`
        .u-mt-lg-minus-1{
            margin-top: -${props => props.theme.space[1]} !important;
        }
        .u-mt-lg-minus-2{
            margin-top: -${props => props.theme.space[2]} !important;
        }
        .u-mt-lg-minus-3{
            margin-top: -${props => props.theme.space[3]} !important;
        }
        .u-mt-lg-minus-4{
            margin-top: -${props => props.theme.space[4]} !important;
        }
        .u-mt-lg-minus-5{
            margin-top: -${props => props.theme.space[5]} !important;
        }
        .u-mt-lg-minus-6{
            margin-top: -${props => props.theme.space[6]} !important;
        }
        .u-mb-lg-minus-1{
            margin-bottom: -${props => props.theme.space[1]} !important;
        }
        .u-mb-lg-minus-2{
            margin-bottom: -${props => props.theme.space[2]} !important;
        }
        .u-mb-lg-minus-3{
            margin-bottom: -${props => props.theme.space[3]} !important;
        }
        .u-mb-lg-minus-4{
            margin-bottom: -${props => props.theme.space[4]} !important;
        }
        .u-mb-lg-minus-5{
            margin-bottom: -${props => props.theme.space[5]} !important;
        }
        .u-mb-lg-minus-6{
            margin-bottom: -${props => props.theme.space[6]} !important;
        }
        .u-ml-lg-minus-1{
            margin-left: -${props => props.theme.space[1]} !important;
        }
        .u-ml-lg-minus-2{
            margin-left: -${props => props.theme.space[2]} !important;
        }
        .u-ml-lg-minus-3{
            margin-left: -${props => props.theme.space[3]} !important;
        }
        .u-ml-lg-minus-4{
            margin-left: -${props => props.theme.space[4]} !important;
        }
        .u-ml-lg-minus-5{
            margin-left: -${props => props.theme.space[5]} !important;
        }
        .u-ml-lg-minus-6{
            margin-left: -${props => props.theme.space[6]} !important;
        }
        .u-mr-lg-minus-1{
            margin-right: -${props => props.theme.space[1]} !important;
        }
        .u-mr-lg-minus-2{
            margin-right: -${props => props.theme.space[2]} !important;
        }
        .u-mr-lg-minus-3{
            margin-right: -${props => props.theme.space[3]} !important;
        }
        .u-mr-lg-minus-4{
            margin-right: -${props => props.theme.space[4]} !important;
        }
        .u-mr-lg-minus-5{
            margin-right: -${props => props.theme.space[5]} !important;
        }
        .u-mr-lg-minus-6{
            margin-right: -${props => props.theme.space[6]} !important;
        }
    `}
    ${media.xl.up`
        .u-mt-xl-minus-1{
            margin-top: -${props => props.theme.space[1]} !important;
        }
        .u-mt-xl-minus-2{
            margin-top: -${props => props.theme.space[2]} !important;
        }
        .u-mt-xl-minus-3{
            margin-top: -${props => props.theme.space[3]} !important;
        }
        .u-mt-xl-minus-4{
            margin-top: -${props => props.theme.space[4]} !important;
        }
        .u-mt-xl-minus-5{
            margin-top: -${props => props.theme.space[5]} !important;
        }
        .u-mt-xl-minus-6{
            margin-top: -${props => props.theme.space[6]} !important;
        }
        .u-mb-xl-minus-1{
            margin-bottom: -${props => props.theme.space[1]} !important;
        }
        .u-mb-xl-minus-2{
            margin-bottom: -${props => props.theme.space[2]} !important;
        }
        .u-mb-xl-minus-3{
            margin-bottom: -${props => props.theme.space[3]} !important;
        }
        .u-mb-xl-minus-4{
            margin-bottom: -${props => props.theme.space[4]} !important;
        }
        .u-mb-xl-minus-5{
            margin-bottom: -${props => props.theme.space[5]} !important;
        }
        .u-mb-xl-minus-6{
            margin-bottom: -${props => props.theme.space[6]} !important;
        }
        .u-ml-xl-minus-1{
            margin-left: -${props => props.theme.space[1]} !important;
        }
        .u-ml-xl-minus-2{
            margin-left: -${props => props.theme.space[2]} !important;
        }
        .u-ml-xl-minus-3{
            margin-left: -${props => props.theme.space[3]} !important;
        }
        .u-ml-xl-minus-4{
            margin-left: -${props => props.theme.space[4]} !important;
        }
        .u-ml-xl-minus-5{
            margin-left: -${props => props.theme.space[5]} !important;
        }
        .u-ml-xl-minus-6{
            margin-left: -${props => props.theme.space[6]} !important;
        }
        .u-mr-xl-minus-1{
            margin-right: -${props => props.theme.space[1]} !important;
        }
        .u-mr-xl-minus-2{
            margin-right: -${props => props.theme.space[2]} !important;
        }
        .u-mr-xl-minus-3{
            margin-right: -${props => props.theme.space[3]} !important;
        }
        .u-mr-xl-minus-4{
            margin-right: -${props => props.theme.space[4]} !important;
        }
        .u-mr-xl-minus-5{
            margin-right: -${props => props.theme.space[5]} !important;
        }
        .u-mr-xl-minus-6{
            margin-right: -${props => props.theme.space[6]} !important;
        }
    `}
    .u-p-0 {
    padding: 0 0 !important;
    }

    .u-pt-0 {
    padding-top: 0 !important;
    }

    .u-pr-0 {
    padding-right: 0 !important;
    }

    .u-pb-0 {
    padding-bottom: 0 !important;
    }

    .u-pl-0 {
    padding-left: 0 !important;
    }

    .u-px-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
    }

    .u-py-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    }

    .u-p-1 {
    padding: ${props => props.theme.space[1]} ${props =>
    props.theme.space[1]} !important;
    }

    .u-pt-1 {
    padding-top: ${props => props.theme.space[1]} !important;
    }

    .u-pr-1 {
    padding-right: ${props => props.theme.space[1]} !important;
    }

    .u-pb-1 {
    padding-bottom: ${props => props.theme.space[1]} !important;
    }

    .u-pl-1 {
    padding-left: ${props => props.theme.space[1]} !important;
    }

    .u-px-1 {
    padding-right: ${props => props.theme.space[1]} !important;
    padding-left: ${props => props.theme.space[1]} !important;
    }

    .u-py-1 {
    padding-top: ${props => props.theme.space[1]} !important;
    padding-bottom: ${props => props.theme.space[1]} !important;
    }

    .u-p-2 {
    padding: ${props => props.theme.space[2]} ${props =>
    props.theme.space[2]} !important;
    }

    .u-pt-2 {
    padding-top: ${props => props.theme.space[2]} !important;
    }

    .u-pr-2 {
    padding-right: ${props => props.theme.space[2]} !important;
    }

    .u-pb-2 {
    padding-bottom: ${props => props.theme.space[2]} !important;
    }

    .u-pl-2 {
    padding-left: ${props => props.theme.space[2]} !important;
    }

    .u-px-2 {
    padding-right: ${props => props.theme.space[2]} !important;
    padding-left: ${props => props.theme.space[2]} !important;
    }

    .u-py-2 {
    padding-top: ${props => props.theme.space[2]} !important;
    padding-bottom: ${props => props.theme.space[2]} !important;
    }

    .u-p-3 {
    padding: ${props => props.theme.space[3]} ${props =>
    props.theme.space[3]} !important;
    }

    .u-pt-3 {
    padding-top: ${props => props.theme.space[3]} !important;
    }

    .u-pr-3 {
    padding-right: ${props => props.theme.space[3]} !important;
    }

    .u-pb-3 {
    padding-bottom: ${props => props.theme.space[3]} !important;
    }

    .u-pl-3 {
    padding-left: ${props => props.theme.space[3]} !important;
    }

    .u-px-3 {
    padding-right: ${props => props.theme.space[3]} !important;
    padding-left: ${props => props.theme.space[3]} !important;
    }

    .u-py-3 {
    padding-top: ${props => props.theme.space[3]} !important;
    padding-bottom: ${props => props.theme.space[3]} !important;
    }

    .u-p-4 {
    padding: ${props => props.theme.space[4]} ${props =>
    props.theme.space[4]} !important;
    }

    .u-pt-4 {
    padding-top: ${props => props.theme.space[4]} !important;
    }

    .u-pr-4 {
    padding-right: ${props => props.theme.space[4]} !important;
    }

    .u-pb-4 {
    padding-bottom: ${props => props.theme.space[4]} !important;
    }

    .u-pl-4 {
    padding-left: ${props => props.theme.space[4]} !important;
    }

    .u-px-4 {
    padding-right: ${props => props.theme.space[4]} !important;
    padding-left: ${props => props.theme.space[4]} !important;
    }

    .u-py-4 {
    padding-top: ${props => props.theme.space[4]} !important;
    padding-bottom: ${props => props.theme.space[4]} !important;
    }

    .u-p-5 {
    padding: ${props => props.theme.space[5]} ${props =>
    props.theme.space[5]} !important;
    }

    .u-pt-5 {
    padding-top: ${props => props.theme.space[5]} !important;
    }

    .u-pr-5 {
    padding-right: ${props => props.theme.space[5]} !important;
    }

    .u-pb-5 {
    padding-bottom: ${props => props.theme.space[5]} !important;
    }

    .u-pl-5 {
    padding-left: ${props => props.theme.space[5]} !important;
    }

    .u-px-5 {
    padding-right: ${props => props.theme.space[5]} !important;
    padding-left: ${props => props.theme.space[5]} !important;
    }

    .u-py-5 {
    padding-top: ${props => props.theme.space[5]} !important;
    padding-bottom: ${props => props.theme.space[5]} !important;
    }
    .u-p-6 {
    padding: ${props => props.theme.space[6]} ${props =>
    props.theme.space[6]} !important;
    }

    .u-pt-6 {
    padding-top: ${props => props.theme.space[6]} !important;
    }

    .u-pr-6 {
    padding-right: ${props => props.theme.space[6]} !important;
    }

    .u-pb-6 {
    padding-bottom: ${props => props.theme.space[6]} !important;
    }

    .u-pl-6 {
    padding-left: ${props => props.theme.space[6]} !important;
    }

    .u-px-6 {
    padding-right: ${props => props.theme.space[6]} !important;
    padding-left: ${props => props.theme.space[6]} !important;
    }

    .u-py-6 {
    padding-top: ${props => props.theme.space[6]} !important;
    padding-bottom: ${props => props.theme.space[6]} !important;
    }
    .u-m-auto {
    margin: auto !important;
    }

    .u-mt-auto {
    margin-top: auto !important;
    }

    .u-mr-auto {
    margin-right: auto !important;
    }

    .u-mb-auto {
    margin-bottom: auto !important;
    }

    .u-ml-auto {
    margin-left: auto !important;
    }

    .u-mx-auto {
    margin-right: auto !important;
    margin-left: auto !important;
    }

    .u-my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
    }
${media.xs.down`
        .u-m-xs-0 {
            margin: 0 0 !important;
        }
        .u-mt-xs-0 {
            margin-top: 0 !important;
        }
        .u-mr-xs-0 {
            margin-right: 0 !important;
        }
        .u-mb-xs-0 {
            margin-bottom: 0 !important;
        }
        .u-ml-xs-0 {
            margin-left: 0 !important;
        }
        .u-mx-xs-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .u-my-xs-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .u-m-xs-1 {
            margin: ${props => props.theme.space[1]} ${props =>
    props.theme.space[1]} !important;
        }
        .u-mt-xs-1 {
            margin-top: ${props => props.theme.space[1]} !important;
        }
        .u-mr-xs-1 {
            margin-right: ${props => props.theme.space[1]} !important;
        }
        .u-mb-xs-1 {
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-ml-xs-1 {
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-mx-xs-1 {
            margin-right: ${props => props.theme.space[1]} !important;
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-my-xs-1 {
            margin-top: ${props => props.theme.space[1]} !important;
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-m-xs-2 {
            margin: ${props => props.theme.space[2]} ${props =>
    props.theme.space[2]} !important;
        }
        .u-mt-xs-2 {
            margin-top: ${props => props.theme.space[2]} !important;
        }
        .u-mr-xs-2 {
            margin-right: ${props => props.theme.space[2]} !important;
        }
        .u-mb-xs-2 {
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-ml-xs-2 {
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-mx-xs-2 {
            margin-right: ${props => props.theme.space[2]} !important;
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-my-xs-2 {
            margin-top: ${props => props.theme.space[2]} !important;
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-m-xs-3 {
            margin: ${props => props.theme.space[3]} ${props =>
    props.theme.space[3]} !important;
        }
        .u-mt-xs-3 {
            margin-top: ${props => props.theme.space[3]} !important;
        }
        .u-mr-xs-3 {
            margin-right: ${props => props.theme.space[3]} !important;
        }
        .u-mb-xs-3 {
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-ml-xs-3 {
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-mx-xs-3 {
            margin-right: ${props => props.theme.space[3]} !important;
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-my-xs-3 {
            margin-top: ${props => props.theme.space[3]} !important;
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-m-xs-4 {
            margin: ${props => props.theme.space[4]} ${props =>
    props.theme.space[4]} !important;
        }
        .u-mt-xs-4 {
            margin-top: ${props => props.theme.space[4]} !important;
        }
        .u-mr-xs-4 {
            margin-right: ${props => props.theme.space[4]} !important;
        }
        .u-mb-xs-4 {
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-ml-xs-4 {
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-mx-xs-4 {
            margin-right: ${props => props.theme.space[4]} !important;
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-my-xs-4 {
            margin-top: ${props => props.theme.space[4]} !important;
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-m-xs-5 {
            margin: ${props => props.theme.space[5]} ${props =>
    props.theme.space[5]} !important;
        }
        .u-mt-xs-5 {
            margin-top: ${props => props.theme.space[5]} !important;
        }
        .u-mr-xs-5 {
            margin-right: ${props => props.theme.space[5]} !important;
        }
        .u-mb-xs-5 {
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-ml-xs-5 {
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-mx-xs-5 {
            margin-right: ${props => props.theme.space[5]} !important;
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-my-xs-5 {
            margin-top: ${props => props.theme.space[5]} !important;
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-m-xs-6 {
            margin: ${props => props.theme.space[6]} ${props =>
    props.theme.space[6]} !important;
        }
        .u-mt-xs-6 {
            margin-top: ${props => props.theme.space[6]} !important;
        }
        .u-mr-xs-6 {
            margin-right: ${props => props.theme.space[6]} !important;
        }
        .u-mb-xs-6 {
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-ml-xs-6 {
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-mx-xs-6 {
            margin-right: ${props => props.theme.space[6]} !important;
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-my-xs-6 {
            margin-top: ${props => props.theme.space[6]} !important;
            margin-bottom: ${props => props.theme.space[6]} !important;
        }

        .u-p-xs-0 {
            padding: 0 0 !important;
        }
        .u-pt-xs-0 {
            padding-top: 0 !important;
        }
        .u-pr-xs-0 {
            padding-right: 0 !important;
        }
        .u-pb-xs-0 {
            padding-bottom: 0 !important;
        }
        .u-pl-xs-0 {
            padding-left: 0 !important;
        }
        .u-px-xs-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .u-py-xs-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .u-p-xs-1 {
            padding: ${props => props.theme.space[1]} ${props =>
    props.theme.space[1]} !important;
        }
        .u-pt-xs-1 {
            padding-top: ${props => props.theme.space[1]} !important;
        }
        .u-pr-xs-1 {
            padding-right: ${props => props.theme.space[1]} !important;
        }
        .u-pb-xs-1 {
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-pl-xs-1 {
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-px-xs-1 {
            padding-right: ${props => props.theme.space[1]} !important;
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-py-xs-1 {
            padding-top: ${props => props.theme.space[1]} !important;
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-p-xs-2 {
            padding: ${props => props.theme.space[2]} ${props =>
    props.theme.space[2]} !important;
        }
        .u-pt-xs-2 {
            padding-top: ${props => props.theme.space[2]} !important;
        }
        .u-pr-xs-2 {
            padding-right: ${props => props.theme.space[2]} !important;
        }
        .u-pb-xs-2 {
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-pl-xs-2 {
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-px-xs-2 {
            padding-right: ${props => props.theme.space[2]} !important;
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-py-xs-2 {
            padding-top: ${props => props.theme.space[2]} !important;
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-p-xs-3 {
            padding: ${props => props.theme.space[3]} ${props =>
    props.theme.space[3]} !important;
        }
        .u-pt-xs-3 {
            padding-top: ${props => props.theme.space[3]} !important;
        }
        .u-pr-xs-3 {
            padding-right: ${props => props.theme.space[3]} !important;
        }
        .u-pb-xs-3 {
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-pl-xs-3 {
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-px-xs-3 {
            padding-right: ${props => props.theme.space[3]} !important;
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-py-xs-3 {
            padding-top: ${props => props.theme.space[3]} !important;
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-p-xs-4 {
            padding: ${props => props.theme.space[4]} ${props =>
    props.theme.space[4]} !important;
        }
        .u-pt-xs-4 {
            padding-top: ${props => props.theme.space[4]} !important;
        }
        .u-pr-xs-4 {
            padding-right: ${props => props.theme.space[4]} !important;
        }
        .u-pb-xs-4 {
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-pl-xs-4 {
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-px-xs-4 {
            padding-right: ${props => props.theme.space[4]} !important;
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-py-xs-4 {
            padding-top: ${props => props.theme.space[4]} !important;
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-p-xs-5 {
            padding: ${props => props.theme.space[5]} ${props =>
    props.theme.space[5]} !important;
        }
        .u-pt-xs-5 {
            padding-top: ${props => props.theme.space[5]} !important;
        }
        .u-pr-xs-5 {
            padding-right: ${props => props.theme.space[5]} !important;
        }
        .u-pb-xs-5 {
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-pl-xs-5 {
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-px-xs-5 {
            padding-right: ${props => props.theme.space[5]} !important;
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-py-xs-5 {
            padding-top: ${props => props.theme.space[5]} !important;
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-p-xs-6 {
            padding: ${props => props.theme.space[6]} ${props =>
    props.theme.space[6]} !important;
        }
        .u-pt-xs-6 {
            padding-top: ${props => props.theme.space[6]} !important;
        }
        .u-pr-xs-6 {
            padding-right: ${props => props.theme.space[6]} !important;
        }
        .u-pb-xs-6 {
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-pl-xs-6 {
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-px-xs-6 {
            padding-right: ${props => props.theme.space[6]} !important;
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-py-xs-6 {
            padding-top: ${props => props.theme.space[6]} !important;
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-m-xs-auto {
            margin: auto !important;
        }
        .u-mt-xs-auto {
            margin-top: auto !important;
        }
        .u-mr-xs-auto {
            margin-right: auto !important;
        }
        .u-mb-xs-auto {
            margin-bottom: auto !important;
        }
        .u-ml-xs-auto {
            margin-left: auto !important;
        }
        .u-mx-xs-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .u-my-xs-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }`}
    ${media.md.down`
        .u-m-sm-0 {
            margin: 0 0 !important;
        }
        .u-mt-sm-0 {
            margin-top: 0 !important;
        }
        .u-mr-sm-0 {
            margin-right: 0 !important;
        }
        .u-mb-sm-0 {
            margin-bottom: 0 !important;
        }
        .u-ml-sm-0 {
            margin-left: 0 !important;
        }
        .u-mx-sm-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .u-my-sm-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .u-m-sm-1 {
            margin: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-mt-sm-1 {
            margin-top: ${props => props.theme.space[1]} !important;
        }
        .u-mr-sm-1 {
            margin-right: ${props => props.theme.space[1]} !important;
        }
        .u-mb-sm-1 {
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-ml-sm-1 {
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-mx-sm-1 {
            margin-right: ${props => props.theme.space[1]} !important;
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-my-sm-1 {
            margin-top: ${props => props.theme.space[1]} !important;
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-m-sm-2 {
            margin: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-mt-sm-2 {
            margin-top: ${props => props.theme.space[2]} !important;
        }
        .u-mr-sm-2 {
            margin-right: ${props => props.theme.space[2]} !important;
        }
        .u-mb-sm-2 {
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-ml-sm-2 {
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-mx-sm-2 {
            margin-right: ${props => props.theme.space[2]} !important;
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-my-sm-2 {
            margin-top: ${props => props.theme.space[2]} !important;
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-m-sm-3 {
            margin: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-mt-sm-3 {
            margin-top: ${props => props.theme.space[3]} !important;
        }
        .u-mr-sm-3 {
            margin-right: ${props => props.theme.space[3]} !important;
        }
        .u-mb-sm-3 {
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-ml-sm-3 {
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-mx-sm-3 {
            margin-right: ${props => props.theme.space[3]} !important;
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-my-sm-3 {
            margin-top: ${props => props.theme.space[3]} !important;
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-m-sm-4 {
            margin: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-mt-sm-4 {
            margin-top: ${props => props.theme.space[4]} !important;
        }
        .u-mr-sm-4 {
            margin-right: ${props => props.theme.space[4]} !important;
        }
        .u-mb-sm-4 {
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-ml-sm-4 {
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-mx-sm-4 {
            margin-right: ${props => props.theme.space[4]} !important;
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-my-sm-4 {
            margin-top: ${props => props.theme.space[4]} !important;
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-m-sm-5 {
            margin: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-mt-sm-5 {
            margin-top: ${props => props.theme.space[5]} !important;
        }
        .u-mr-sm-5 {
            margin-right: ${props => props.theme.space[5]} !important;
        }
        .u-mb-sm-5 {
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-ml-sm-5 {
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-mx-sm-5 {
            margin-right: ${props => props.theme.space[5]} !important;
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-my-sm-5 {
            margin-top: ${props => props.theme.space[5]} !important;
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-m-sm-6 {
            margin: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-mt-sm-6 {
            margin-top: ${props => props.theme.space[6]} !important;
        }
        .u-mr-sm-6 {
            margin-right: ${props => props.theme.space[6]} !important;
        }
        .u-mb-sm-6 {
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-ml-sm-6 {
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-mx-sm-6 {
            margin-right: ${props => props.theme.space[6]} !important;
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-my-sm-6 {
            margin-top: ${props => props.theme.space[6]} !important;
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-p-sm-0 {
            padding: 0 0 !important;
        }
        .u-pt-sm-0 {
            padding-top: 0 !important;
        }
        .u-pr-sm-0 {
            padding-right: 0 !important;
        }
        .u-pb-sm-0 {
            padding-bottom: 0 !important;
        }
        .u-pl-sm-0 {
            padding-left: 0 !important;
        }
        .u-px-sm-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .u-py-sm-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .u-p-sm-1 {
            padding: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-pt-sm-1 {
            padding-top: ${props => props.theme.space[1]} !important;
        }
        .u-pr-sm-1 {
            padding-right: ${props => props.theme.space[1]} !important;
        }
        .u-pb-sm-1 {
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-pl-sm-1 {
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-px-sm-1 {
            padding-right: ${props => props.theme.space[1]} !important;
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-py-sm-1 {
            padding-top: ${props => props.theme.space[1]} !important;
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-p-sm-2 {
            padding: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-pt-sm-2 {
            padding-top: ${props => props.theme.space[2]} !important;
        }
        .u-pr-sm-2 {
            padding-right: ${props => props.theme.space[2]} !important;
        }
        .u-pb-sm-2 {
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-pl-sm-2 {
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-px-sm-2 {
            padding-right: ${props => props.theme.space[2]} !important;
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-py-sm-2 {
            padding-top: ${props => props.theme.space[2]} !important;
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-p-sm-3 {
            padding: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-pt-sm-3 {
            padding-top: ${props => props.theme.space[3]} !important;
        }
        .u-pr-sm-3 {
            padding-right: ${props => props.theme.space[3]} !important;
        }
        .u-pb-sm-3 {
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-pl-sm-3 {
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-px-sm-3 {
            padding-right: ${props => props.theme.space[3]} !important;
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-py-sm-3 {
            padding-top: ${props => props.theme.space[3]} !important;
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-p-sm-4 {
            padding: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-pt-sm-4 {
            padding-top: ${props => props.theme.space[4]} !important;
        }
        .u-pr-sm-4 {
            padding-right: ${props => props.theme.space[4]} !important;
        }
        .u-pb-sm-4 {
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-pl-sm-4 {
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-px-sm-4 {
            padding-right: ${props => props.theme.space[4]} !important;
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-py-sm-4 {
            padding-top: ${props => props.theme.space[4]} !important;
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-p-sm-5 {
            padding: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-pt-sm-5 {
            padding-top: ${props => props.theme.space[5]} !important;
        }
        .u-pr-sm-5 {
            padding-right: ${props => props.theme.space[5]} !important;
        }
        .u-pb-sm-5 {
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-pl-sm-5 {
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-px-sm-5 {
            padding-right: ${props => props.theme.space[5]} !important;
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-py-sm-5 {
            padding-top: ${props => props.theme.space[5]} !important;
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-p-sm-6 {
            padding: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-pt-sm-6 {
            padding-top: ${props => props.theme.space[6]} !important;
        }
        .u-pr-sm-6 {
            padding-right: ${props => props.theme.space[6]} !important;
        }
        .u-pb-sm-6 {
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-pl-sm-6 {
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-px-sm-6 {
            padding-right: ${props => props.theme.space[6]} !important;
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-py-sm-6 {
            padding-top: ${props => props.theme.space[6]} !important;
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-m-sm-auto {
            margin: auto !important;
        }
        .u-mt-sm-auto {
            margin-top: auto !important;
        }
        .u-mr-sm-auto {
            margin-right: auto !important;
        }
        .u-mb-sm-auto {
            margin-bottom: auto !important;
        }
        .u-ml-sm-auto {
            margin-left: auto !important;
        }
        .u-mx-sm-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .u-my-sm-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }`}

    ${media.md.up`
        .u-m-md-0 {
            margin: 0 0 !important;
        }
        .u-mt-md-0 {
            margin-top: 0 !important;
        }
        .u-mr-md-0 {
            margin-right: 0 !important;
        }
        .u-mb-md-0 {
            margin-bottom: 0 !important;
        }
        .u-ml-md-0 {
            margin-left: 0 !important;
        }
        .u-mx-md-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .u-my-md-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .u-m-md-1 {
            margin: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-mt-md-1 {
            margin-top: ${props => props.theme.space[1]} !important;
        }
        .u-mr-md-1 {
            margin-right: ${props => props.theme.space[1]} !important;
        }
        .u-mb-md-1 {
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-ml-md-1 {
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-mx-md-1 {
            margin-right: ${props => props.theme.space[1]} !important;
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-my-md-1 {
            margin-top: ${props => props.theme.space[1]} !important;
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-m-md-2 {
            margin: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-mt-md-2 {
            margin-top: ${props => props.theme.space[2]} !important;
        }
        .u-mr-md-2 {
            margin-right: ${props => props.theme.space[2]} !important;
        }
        .u-mb-md-2 {
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-ml-md-2 {
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-mx-md-2 {
            margin-right: ${props => props.theme.space[2]} !important;
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-my-md-2 {
            margin-top: ${props => props.theme.space[2]} !important;
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-m-md-3 {
            margin: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-mt-md-3 {
            margin-top: ${props => props.theme.space[3]} !important;
        }
        .u-mr-md-3 {
            margin-right: ${props => props.theme.space[3]} !important;
        }
        .u-mb-md-3 {
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-ml-md-3 {
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-mx-md-3 {
            margin-right: ${props => props.theme.space[3]} !important;
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-my-md-3 {
            margin-top: ${props => props.theme.space[3]} !important;
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-m-md-4 {
            margin: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-mt-md-4 {
            margin-top: ${props => props.theme.space[4]} !important;
        }
        .u-mr-md-4 {
            margin-right: ${props => props.theme.space[4]} !important;
        }
        .u-mb-md-4 {
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-ml-md-4 {
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-mx-md-4 {
            margin-right: ${props => props.theme.space[4]} !important;
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-my-md-4 {
            margin-top: ${props => props.theme.space[4]} !important;
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-m-md-5 {
            margin: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-mt-md-5 {
            margin-top: ${props => props.theme.space[5]} !important;
        }
        .u-mr-md-5 {
            margin-right: ${props => props.theme.space[5]} !important;
        }
        .u-mb-md-5 {
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-ml-md-5 {
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-mx-md-5 {
            margin-right: ${props => props.theme.space[5]} !important;
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-my-md-5 {
            margin-top: ${props => props.theme.space[5]} !important;
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-m-md-6 {
            margin: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-mt-md-6 {
            margin-top: ${props => props.theme.space[6]} !important;
        }
        .u-mr-md-6 {
            margin-right: ${props => props.theme.space[6]} !important;
        }
        .u-mb-md-6 {
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-ml-md-6 {
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-mx-md-6 {
            margin-right: ${props => props.theme.space[6]} !important;
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-my-md-6 {
            margin-top: ${props => props.theme.space[6]} !important;
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-p-md-0 {
            padding: 0 0 !important;
        }
        .u-pt-md-0 {
            padding-top: 0 !important;
        }
        .u-pr-md-0 {
            padding-right: 0 !important;
        }
        .u-pb-md-0 {
            padding-bottom: 0 !important;
        }
        .u-pl-md-0 {
            padding-left: 0 !important;
        }
        .u-px-md-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .u-py-md-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .u-p-md-1 {
            padding: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-pt-md-1 {
            padding-top: ${props => props.theme.space[1]} !important;
        }
        .u-pr-md-1 {
            padding-right: ${props => props.theme.space[1]} !important;
        }
        .u-pb-md-1 {
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-pl-md-1 {
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-px-md-1 {
            padding-right: ${props => props.theme.space[1]} !important;
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-py-md-1 {
            padding-top: ${props => props.theme.space[1]} !important;
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-p-md-2 {
            padding: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-pt-md-2 {
            padding-top: ${props => props.theme.space[2]} !important;
        }
        .u-pr-md-2 {
            padding-right: ${props => props.theme.space[2]} !important;
        }
        .u-pb-md-2 {
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-pl-md-2 {
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-px-md-2 {
            padding-right: ${props => props.theme.space[2]} !important;
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-py-md-2 {
            padding-top: ${props => props.theme.space[2]} !important;
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-p-md-3 {
            padding: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-pt-md-3 {
            padding-top: ${props => props.theme.space[3]} !important;
        }
        .u-pr-md-3 {
            padding-right: ${props => props.theme.space[3]} !important;
        }
        .u-pb-md-3 {
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-pl-md-3 {
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-px-md-3 {
            padding-right: ${props => props.theme.space[3]} !important;
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-py-md-3 {
            padding-top: ${props => props.theme.space[3]} !important;
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-p-md-4 {
            padding: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-pt-md-4 {
            padding-top: ${props => props.theme.space[4]} !important;
        }
        .u-pr-md-4 {
            padding-right: ${props => props.theme.space[4]} !important;
        }
        .u-pb-md-4 {
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-pl-md-4 {
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-px-md-4 {
            padding-right: ${props => props.theme.space[4]} !important;
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-py-md-4 {
            padding-top: ${props => props.theme.space[4]} !important;
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-p-md-5 {
            padding: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-pt-md-5 {
            padding-top: ${props => props.theme.space[5]} !important;
        }
        .u-pr-md-5 {
            padding-right: ${props => props.theme.space[5]} !important;
        }
        .u-pb-md-5 {
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-pl-md-5 {
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-px-md-5 {
            padding-right: ${props => props.theme.space[5]} !important;
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-py-md-5 {
            padding-top: ${props => props.theme.space[5]} !important;
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-p-md-6 {
            padding: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-pt-md-6 {
            padding-top: ${props => props.theme.space[6]} !important;
        }
        .u-pr-md-6 {
            padding-right: ${props => props.theme.space[6]} !important;
        }
        .u-pb-md-6 {
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-pl-md-6 {
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-px-md-6 {
            padding-right: ${props => props.theme.space[6]} !important;
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-py-md-6 {
            padding-top: ${props => props.theme.space[6]} !important;
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-m-md-auto {
            margin: auto !important;
        }
        .u-mt-md-auto {
            margin-top: auto !important;
        }
        .u-mr-md-auto {
            margin-right: auto !important;
        }
        .u-mb-md-auto {
            margin-bottom: auto !important;
        }
        .u-ml-md-auto {
            margin-left: auto !important;
        }
        .u-mx-md-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .u-my-md-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }`}

    ${media.lg.up`
        .u-m-lg-0 {
            margin: 0 0 !important;
        }
        .u-mt-lg-0 {
            margin-top: 0 !important;
        }
        .u-mr-lg-0 {
            margin-right: 0 !important;
        }
        .u-mb-lg-0 {
            margin-bottom: 0 !important;
        }
        .u-ml-lg-0 {
            margin-left: 0 !important;
        }
        .u-mx-lg-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .u-my-lg-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .u-m-lg-1 {
            margin: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-mt-lg-1 {
            margin-top: ${props => props.theme.space[1]} !important;
        }
        .u-mr-lg-1 {
            margin-right: ${props => props.theme.space[1]} !important;
        }
        .u-mb-lg-1 {
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-ml-lg-1 {
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-mx-lg-1 {
            margin-right: ${props => props.theme.space[1]} !important;
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-my-lg-1 {
            margin-top: ${props => props.theme.space[1]} !important;
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-m-lg-2 {
            margin: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-mt-lg-2 {
            margin-top: ${props => props.theme.space[2]} !important;
        }
        .u-mr-lg-2 {
            margin-right: ${props => props.theme.space[2]} !important;
        }
        .u-mb-lg-2 {
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-ml-lg-2 {
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-mx-lg-2 {
            margin-right: ${props => props.theme.space[2]} !important;
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-my-lg-2 {
            margin-top: ${props => props.theme.space[2]} !important;
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-m-lg-3 {
            margin: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-mt-lg-3 {
            margin-top: ${props => props.theme.space[3]} !important;
        }
        .u-mr-lg-3 {
            margin-right: ${props => props.theme.space[3]} !important;
        }
        .u-mb-lg-3 {
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-ml-lg-3 {
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-mx-lg-3 {
            margin-right: ${props => props.theme.space[3]} !important;
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-my-lg-3 {
            margin-top: ${props => props.theme.space[3]} !important;
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-m-lg-4 {
            margin: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-mt-lg-4 {
            margin-top: ${props => props.theme.space[4]} !important;
        }
        .u-mr-lg-4 {
            margin-right: ${props => props.theme.space[4]} !important;
        }
        .u-mb-lg-4 {
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-ml-lg-4 {
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-mx-lg-4 {
            margin-right: ${props => props.theme.space[4]} !important;
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-my-lg-4 {
            margin-top: ${props => props.theme.space[4]} !important;
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-m-lg-5 {
            margin: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-mt-lg-5 {
            margin-top: ${props => props.theme.space[5]} !important;
        }
        .u-mr-lg-5 {
            margin-right: ${props => props.theme.space[5]} !important;
        }
        .u-mb-lg-5 {
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-ml-lg-5 {
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-mx-lg-5 {
            margin-right: ${props => props.theme.space[5]} !important;
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-my-lg-5 {
            margin-top: ${props => props.theme.space[5]} !important;
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-m-lg-6 {
            margin: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-mt-lg-6 {
            margin-top: ${props => props.theme.space[6]} !important;
        }
        .u-mr-lg-6 {
            margin-right: ${props => props.theme.space[6]} !important;
        }
        .u-mb-lg-6 {
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-ml-lg-6 {
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-mx-lg-6 {
            margin-right: ${props => props.theme.space[6]} !important;
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-my-lg-6 {
            margin-top: ${props => props.theme.space[6]} !important;
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-p-lg-0 {
            padding: 0 0 !important;
        }
        .u-pt-lg-0 {
            padding-top: 0 !important;
        }
        .u-pr-lg-0 {
            padding-right: 0 !important;
        }
        .u-pb-lg-0 {
            padding-bottom: 0 !important;
        }
        .u-pl-lg-0 {
            padding-left: 0 !important;
        }
        .u-px-lg-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .u-py-lg-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .u-p-lg-1 {
            padding: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-pt-lg-1 {
            padding-top: ${props => props.theme.space[1]} !important;
        }
        .u-pr-lg-1 {
            padding-right: ${props => props.theme.space[1]} !important;
        }
        .u-pb-lg-1 {
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-pl-lg-1 {
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-px-lg-1 {
            padding-right: ${props => props.theme.space[1]} !important;
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-py-lg-1 {
            padding-top: ${props => props.theme.space[1]} !important;
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-p-lg-2 {
            padding: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-pt-lg-2 {
            padding-top: ${props => props.theme.space[2]} !important;
        }
        .u-pr-lg-2 {
            padding-right: ${props => props.theme.space[2]} !important;
        }
        .u-pb-lg-2 {
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-pl-lg-2 {
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-px-lg-2 {
            padding-right: ${props => props.theme.space[2]} !important;
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-py-lg-2 {
            padding-top: ${props => props.theme.space[2]} !important;
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-p-lg-3 {
            padding: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-pt-lg-3 {
            padding-top: ${props => props.theme.space[3]} !important;
        }
        .u-pr-lg-3 {
            padding-right: ${props => props.theme.space[3]} !important;
        }
        .u-pb-lg-3 {
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-pl-lg-3 {
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-px-lg-3 {
            padding-right: ${props => props.theme.space[3]} !important;
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-py-lg-3 {
            padding-top: ${props => props.theme.space[3]} !important;
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-p-lg-4 {
            padding: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-pt-lg-4 {
            padding-top: ${props => props.theme.space[4]} !important;
        }
        .u-pr-lg-4 {
            padding-right: ${props => props.theme.space[4]} !important;
        }
        .u-pb-lg-4 {
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-pl-lg-4 {
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-px-lg-4 {
            padding-right: ${props => props.theme.space[4]} !important;
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-py-lg-4 {
            padding-top: ${props => props.theme.space[4]} !important;
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-p-lg-5 {
            padding: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-pt-lg-5 {
            padding-top: ${props => props.theme.space[5]} !important;
        }
        .u-pr-lg-5 {
            padding-right: ${props => props.theme.space[5]} !important;
        }
        .u-pb-lg-5 {
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-pl-lg-5 {
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-px-lg-5 {
            padding-right: ${props => props.theme.space[5]} !important;
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-py-lg-5 {
            padding-top: ${props => props.theme.space[5]} !important;
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-p-lg-6 {
            padding: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-pt-lg-6 {
            padding-top: ${props => props.theme.space[6]} !important;
        }
        .u-pr-lg-6 {
            padding-right: ${props => props.theme.space[6]} !important;
        }
        .u-pb-lg-6 {
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-pl-lg-6 {
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-px-lg-6 {
            padding-right: ${props => props.theme.space[6]} !important;
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-py-lg-6 {
            padding-top: ${props => props.theme.space[6]} !important;
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-m-lg-auto {
            margin: auto !important;
        }
        .u-mt-lg-auto {
            margin-top: auto !important;
        }
        .u-mr-lg-auto {
            margin-right: auto !important;
        }
        .u-mb-lg-auto {
            margin-bottom: auto !important;
        }
        .u-ml-lg-auto {
            margin-left: auto !important;
        }
        .u-mx-lg-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .u-my-lg-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }`}

    ${media.xl.up`
        .u-m-xl-0 {
            margin: 0 0 !important;
        }
        .u-mt-xl-0 {
            margin-top: 0 !important;
        }
        .u-mr-xl-0 {
            margin-right: 0 !important;
        }
        .u-mb-xl-0 {
            margin-bottom: 0 !important;
        }
        .u-ml-xl-0 {
            margin-left: 0 !important;
        }
        .u-mx-xl-0 {
            margin-right: 0 !important;
            margin-left: 0 !important;
        }
        .u-my-xl-0 {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        .u-m-xl-1 {
            margin: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-mt-xl-1 {
            margin-top: ${props => props.theme.space[1]} !important;
        }
        .u-mr-xl-1 {
            margin-right: ${props => props.theme.space[1]} !important;
        }
        .u-mb-xl-1 {
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-ml-xl-1 {
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-mx-xl-1 {
            margin-right: ${props => props.theme.space[1]} !important;
            margin-left: ${props => props.theme.space[1]} !important;
        }
        .u-my-xl-1 {
            margin-top: ${props => props.theme.space[1]} !important;
            margin-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-m-xl-2 {
            margin: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-mt-xl-2 {
            margin-top: ${props => props.theme.space[2]} !important;
        }
        .u-mr-xl-2 {
            margin-right: ${props => props.theme.space[2]} !important;
        }
        .u-mb-xl-2 {
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-ml-xl-2 {
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-mx-xl-2 {
            margin-right: ${props => props.theme.space[2]} !important;
            margin-left: ${props => props.theme.space[2]} !important;
        }
        .u-my-xl-2 {
            margin-top: ${props => props.theme.space[2]} !important;
            margin-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-m-xl-3 {
            margin: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-mt-xl-3 {
            margin-top: ${props => props.theme.space[3]} !important;
        }
        .u-mr-xl-3 {
            margin-right: ${props => props.theme.space[3]} !important;
        }
        .u-mb-xl-3 {
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-ml-xl-3 {
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-mx-xl-3 {
            margin-right: ${props => props.theme.space[3]} !important;
            margin-left: ${props => props.theme.space[3]} !important;
        }
        .u-my-xl-3 {
            margin-top: ${props => props.theme.space[3]} !important;
            margin-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-m-xl-4 {
            margin: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-mt-xl-4 {
            margin-top: ${props => props.theme.space[4]} !important;
        }
        .u-mr-xl-4 {
            margin-right: ${props => props.theme.space[4]} !important;
        }
        .u-mb-xl-4 {
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-ml-xl-4 {
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-mx-xl-4 {
            margin-right: ${props => props.theme.space[4]} !important;
            margin-left: ${props => props.theme.space[4]} !important;
        }
        .u-my-xl-4 {
            margin-top: ${props => props.theme.space[4]} !important;
            margin-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-m-xl-5 {
            margin: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-mt-xl-5 {
            margin-top: ${props => props.theme.space[5]} !important;
        }
        .u-mr-xl-5 {
            margin-right: ${props => props.theme.space[5]} !important;
        }
        .u-mb-xl-5 {
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-ml-xl-5 {
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-mx-xl-5 {
            margin-right: ${props => props.theme.space[5]} !important;
            margin-left: ${props => props.theme.space[5]} !important;
        }
        .u-my-xl-5 {
            margin-top: ${props => props.theme.space[5]} !important;
            margin-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-m-xl-6 {
            margin: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-mt-xl-6 {
            margin-top: ${props => props.theme.space[6]} !important;
        }
        .u-mr-xl-6 {
            margin-right: ${props => props.theme.space[6]} !important;
        }
        .u-mb-xl-6 {
            margin-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-ml-xl-6 {
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-mx-xl-6 {
            margin-right: ${props => props.theme.space[6]} !important;
            margin-left: ${props => props.theme.space[6]} !important;
        }
        .u-my-xl-6 {
            margin-top: ${props => props.theme.space[6]} !important;
            margin-bottom: ${props => props.theme.space[6]} !important;
        }

        .u-p-xl-0 {
            padding: 0 0 !important;
        }
        .u-pt-xl-0 {
            padding-top: 0 !important;
        }
        .u-pr-xl-0 {
            padding-right: 0 !important;
        }
        .u-pb-xl-0 {
            padding-bottom: 0 !important;
        }
        .u-pl-xl-0 {
            padding-left: 0 !important;
        }
        .u-px-xl-0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .u-py-xl-0 {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .u-p-xl-1 {
            padding: ${props => props.theme.space[1]} ${props =>
        props.theme.space[1]} !important;
        }
        .u-pt-xl-1 {
            padding-top: ${props => props.theme.space[1]} !important;
        }
        .u-pr-xl-1 {
            padding-right: ${props => props.theme.space[1]} !important;
        }
        .u-pb-xl-1 {
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-pl-xl-1 {
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-px-xl-1 {
            padding-right: ${props => props.theme.space[1]} !important;
            padding-left: ${props => props.theme.space[1]} !important;
        }
        .u-py-xl-1 {
            padding-top: ${props => props.theme.space[1]} !important;
            padding-bottom: ${props => props.theme.space[1]} !important;
        }
        .u-p-xl-2 {
            padding: ${props => props.theme.space[2]} ${props =>
        props.theme.space[2]} !important;
        }
        .u-pt-xl-2 {
            padding-top: ${props => props.theme.space[2]} !important;
        }
        .u-pr-xl-2 {
            padding-right: ${props => props.theme.space[2]} !important;
        }
        .u-pb-xl-2 {
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-pl-xl-2 {
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-px-xl-2 {
            padding-right: ${props => props.theme.space[2]} !important;
            padding-left: ${props => props.theme.space[2]} !important;
        }
        .u-py-xl-2 {
            padding-top: ${props => props.theme.space[2]} !important;
            padding-bottom: ${props => props.theme.space[2]} !important;
        }
        .u-p-xl-3 {
            padding: ${props => props.theme.space[3]} ${props =>
        props.theme.space[3]} !important;
        }
        .u-pt-xl-3 {
            padding-top: ${props => props.theme.space[3]} !important;
        }
        .u-pr-xl-3 {
            padding-right: ${props => props.theme.space[3]} !important;
        }
        .u-pb-xl-3 {
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-pl-xl-3 {
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-px-xl-3 {
            padding-right: ${props => props.theme.space[3]} !important;
            padding-left: ${props => props.theme.space[3]} !important;
        }
        .u-py-xl-3 {
            padding-top: ${props => props.theme.space[3]} !important;
            padding-bottom: ${props => props.theme.space[3]} !important;
        }
        .u-p-xl-4 {
            padding: ${props => props.theme.space[4]} ${props =>
        props.theme.space[4]} !important;
        }
        .u-pt-xl-4 {
            padding-top: ${props => props.theme.space[4]} !important;
        }
        .u-pr-xl-4 {
            padding-right: ${props => props.theme.space[4]} !important;
        }
        .u-pb-xl-4 {
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-pl-xl-4 {
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-px-xl-4 {
            padding-right: ${props => props.theme.space[4]} !important;
            padding-left: ${props => props.theme.space[4]} !important;
        }
        .u-py-xl-4 {
            padding-top: ${props => props.theme.space[4]} !important;
            padding-bottom: ${props => props.theme.space[4]} !important;
        }
        .u-p-xl-5 {
            padding: ${props => props.theme.space[5]} ${props =>
        props.theme.space[5]} !important;
        }
        .u-pt-xl-5 {
            padding-top: ${props => props.theme.space[5]} !important;
        }
        .u-pr-xl-5 {
            padding-right: ${props => props.theme.space[5]} !important;
        }
        .u-pb-xl-5 {
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-pl-xl-5 {
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-px-xl-5 {
            padding-right: ${props => props.theme.space[5]} !important;
            padding-left: ${props => props.theme.space[5]} !important;
        }
        .u-py-xl-5 {
            padding-top: ${props => props.theme.space[5]} !important;
            padding-bottom: ${props => props.theme.space[5]} !important;
        }
        .u-p-xl-6 {
            padding: ${props => props.theme.space[6]} ${props =>
        props.theme.space[6]} !important;
        }
        .u-pt-xl-6 {
            padding-top: ${props => props.theme.space[6]} !important;
        }
        .u-pr-xl-6 {
            padding-right: ${props => props.theme.space[6]} !important;
        }
        .u-pb-xl-6 {
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-pl-xl-6 {
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-px-xl-6 {
            padding-right: ${props => props.theme.space[6]} !important;
            padding-left: ${props => props.theme.space[6]} !important;
        }
        .u-py-xl-6 {
            padding-top: ${props => props.theme.space[6]} !important;
            padding-bottom: ${props => props.theme.space[6]} !important;
        }
        .u-m-xl-auto {
            margin: auto !important;
        }
        .u-mt-xl-auto {
            margin-top: auto !important;
        }
        .u-mr-xl-auto {
            margin-right: auto !important;
        }
        .u-mb-xl-auto {
            margin-bottom: auto !important;
        }
        .u-ml-xl-auto {
            margin-left: auto !important;
        }
        .u-mx-xl-auto {
            margin-right: auto !important;
            margin-left: auto !important;
        }
        .u-my-xl-auto {
            margin-top: auto !important;
            margin-bottom: auto !important;
        }`}

    ${"" /* Text Colours - responsive classes */}
    .u-color-primary, .u-color-primary *:not(a){
        color: ${props => props.theme.colors.primary} !important;
    }
    .u-color-primaryTone, .u-color-primaryTone *:not(a){
        color: ${props => props.theme.colors.primaryTone} !important;
    }
    .u-color-secondary, .u-color-secondary *:not(a){
        color: ${props => props.theme.colors.secondary} !important;
    }
    .u-color-secondaryTone, .u-color-secondaryTone *:not(a){
        color: ${props => props.theme.colors.secondaryTone} !important;
    }
    .u-color-tertiary, .u-color-tertiary *:not(a){
        color: ${props => props.theme.colors.tertiary} !important;
    }
    .u-color-monotoneMid, .u-color-monotoneMid *:not(a){
        color: ${props => props.theme.colors.monotoneMid} !important;
    }
    .u-color-monotoneMidDark, .u-color-monotoneMidDark *:not(a){
        color: ${props => props.theme.colors.monotoneMidDark} !important;
    }
    .u-color-monotoneDark, .u-color-monotoneDark *:not(a){
        color: ${props => props.theme.colors.monotoneDark} !important;
    }
    .u-color-alert, .u-color-alert *:not(a){
        color: ${props => props.theme.colors.alert} !important;
    }
    .u-color-accentPrimary, .u-color-accentPrimary *:not(a){
        color: ${props => props.theme.colors.accentPrimary} !important;
    }
    .u-color-accentSecondary, .u-color-accentSecondary *:not(a){
        color: ${props => props.theme.colors.accentSecondary} !important;
    }
    .u-color-accent3, .u-color-accent3 *:not(a){
        color: ${props => props.theme.colors.accent3} !important;
    }
    .u-color-accent4, .u-color-accent4 *:not(a){
        color: ${props => props.theme.colors.accent4} !important;
    }
    .u-color-brilliant, .u-color-brilliant *:not(a){
        color: ${props => props.theme.colors.brilliant} !important;
    }

    ${media.sm.only`
        .u-color-sm-primary, .u-color-sm-primary *:not(a){
            color: ${props => props.theme.colors.primary} !important;
        }
        .u-color-sm-primaryTone, .u-color-sm-primaryTone *:not(a){
            color: ${props => props.theme.colors.primaryTone} !important;
        }
        .u-color-sm-secondary, .u-color-sm-secondary *:not(a){
            color: ${props => props.theme.colors.secondary} !important;
        }
        .u-color-sm-secondaryTone, .u-color-sm-secondaryTone *:not(a){
            color: ${props => props.theme.colors.secondaryTone} !important;
        }
        .u-color-sm-tertiary, .u-color-sm-tertiary *:not(a){
            color: ${props => props.theme.colors.tertiary} !important;
        }
        .u-color-sm-monotoneMid, .u-color-sm-monotoneMid *:not(a){
            color: ${props => props.theme.colors.monotoneMid} !important;
        }
        .u-color-sm-monotoneMidDark, .u-color-sm-monotoneMidDark *:not(a){
            color: ${props => props.theme.colors.monotoneMidDark} !important;
        }
        .u-color-sm-monotoneDark, .u-color-sm-monotoneDark *:not(a){
            color: ${props => props.theme.colors.monotoneDark} !important;
        }
        .u-color-sm-alert, .u-color-sm-alert *:not(a){
            color: ${props => props.theme.colors.alert} !important;
        }
        .u-color-sm-accentPrimary, .u-color-sm-accentPrimary *:not(a){
            color: ${props => props.theme.colors.accentPrimary} !important;
        }
        .u-color-sm-accentSecondary, .u-color-sm-accentSecondary *:not(a){
            color: ${props => props.theme.colors.accentSecondary} !important;
        }
        .u-color-sm-accent3, .u-color-sm-accent3 *:not(a){
            color: ${props => props.theme.colors.accent3} !important;
        }
        .u-color-sm-accent4, .u-color-sm-accent4 *:not(a){
            color: ${props => props.theme.colors.accent4} !important;
        }
        .u-color-sm-brilliant, .u-color-sm-brilliant *:not(a){
            color: ${props => props.theme.colors.brilliant} !important;
        }
    `}
    ${media.md.only`
        .u-color-md-primary, .u-color-md-primary *:not(a){
            color: ${props => props.theme.colors.primary} !important;
        }
        .u-color-md-primaryTone, .u-color-md-primaryTone *:not(a){
            color: ${props => props.theme.colors.primaryTone} !important;
        }
        .u-color-md-secondary, .u-color-md-secondary *:not(a){
            color: ${props => props.theme.colors.secondary} !important;
        }
        .u-color-md-secondaryTone, .u-color-md-secondaryTone *:not(a){
            color: ${props => props.theme.colors.secondaryTone} !important;
        }
        .u-color-md-tertiary, .u-color-md-tertiary *:not(a){
            color: ${props => props.theme.colors.tertiary} !important;
        }
        .u-color-md-monotoneMid, .u-color-md-monotoneMid *:not(a){
            color: ${props => props.theme.colors.monotoneMid} !important;
        }
        .u-color-md-monotoneMidDark, .u-color-md-monotoneMidDark *:not(a){
            color: ${props => props.theme.colors.monotoneMidDark} !important;
        }
        .u-color-md-monotoneDark, .u-color-md-monotoneDark *:not(a){
            color: ${props => props.theme.colors.monotoneDark} !important;
        }
        .u-color-md-alert, .u-color-md-alert *:not(a){
            color: ${props => props.theme.colors.alert} !important;
        }
        .u-color-md-accentPrimary, .u-color-md-accentPrimary *:not(a){
            color: ${props => props.theme.colors.accentPrimary} !important;
        }
        .u-color-md-accentSecondary, .u-color-md-accentSecondary *:not(a){
            color: ${props => props.theme.colors.accentSecondary} !important;
        }
        .u-color-md-accent3, .u-color-md-accent3 *:not(a){
            color: ${props => props.theme.colors.accent3} !important;
        }
        .u-color-md-accent4, .u-color-md-accent4 *:not(a){
            color: ${props => props.theme.colors.accent4} !important;
        }
        .u-color-md-brilliant, .u-color-md-brilliant *:not(a){
            color: ${props => props.theme.colors.brilliant} !important;
        }
    `}
    ${media.lg.only`
        .u-color-lg-primary, .u-color-lg-primary *:not(a){
            color: ${props => props.theme.colors.primary} !important;
        }
        .u-color-lg-primaryTone, .u-color-lg-primaryTone *:not(a){
            color: ${props => props.theme.colors.primaryTone} !important;
        }
        .u-color-lg-secondary, .u-color-lg-secondary *:not(a){
            color: ${props => props.theme.colors.secondary} !important;
        }
        .u-color-lg-secondaryTone, .u-color-lg-secondaryTone *:not(a){
            color: ${props => props.theme.colors.secondaryTone} !important;
        }
        .u-color-lg-tertiary, .u-color-lg-tertiary *:not(a){
            color: ${props => props.theme.colors.tertiary} !important;
        }
        .u-color-lg-monotoneMid, .u-color-lg-monotoneMid *:not(a){
            color: ${props => props.theme.colors.monotoneMid} !important;
        }
        .u-color-lg-monotoneMidDark, .u-color-lg-monotoneMidDark *:not(a){
            color: ${props => props.theme.colors.monotoneMidDark} !important;
        }
        .u-color-lg-monotoneDark, .u-color-lg-monotoneDark *:not(a){
            color: ${props => props.theme.colors.monotoneDark} !important;
        }
        .u-color-lg-alert, .u-color-lg-alert *:not(a){
            color: ${props => props.theme.colors.alert} !important;
        }
        .u-color-lg-accentPrimary, .u-color-lg-accentPrimary *:not(a){
            color: ${props => props.theme.colors.accentPrimary} !important;
        }
        .u-color-lg-accentSecondary, .u-color-lg-accentSecondary *:not(a){
            color: ${props => props.theme.colors.accentSecondary} !important;
        }
        .u-color-lg-accent3, .u-color-lg-accent3 *:not(a){
            color: ${props => props.theme.colors.accent3} !important;
        }
        .u-color-lg-accent4, .u-color-lg-accent4 *:not(a){
            color: ${props => props.theme.colors.accent4} !important;
        }
        .u-color-lg-brilliant, .u-color-lg-brilliant *:not(a){
            color: ${props => props.theme.colors.brilliant} !important;
        }
    `}
    ${media.xl.only`
        .u-color-xl-primary, .u-color-xl-primary *:not(a){
            color: ${props => props.theme.colors.primary} !important;
        }
        .u-color-xl-primaryTone, .u-color-xl-primaryTone *:not(a){
            color: ${props => props.theme.colors.primaryTone} !important;
        }
        .u-color-xl-secondary, .u-color-xl-secondary *:not(a){
            color: ${props => props.theme.colors.secondary} !important;
        }
        .u-color-xl-secondaryTone, .u-color-xl-secondaryTone *:not(a){
            color: ${props => props.theme.colors.secondaryTone} !important;
        }
        .u-color-xl-tertiary, .u-color-xl-tertiary *:not(a){
            color: ${props => props.theme.colors.tertiary} !important;
        }
        .u-color-xl-monotoneMid, .u-color-xl-monotoneMid *:not(a){
            color: ${props => props.theme.colors.monotoneMid} !important;
        }
        .u-color-xl-monotoneMidDark, .u-color-xl-monotoneMidDark *:not(a){
            color: ${props => props.theme.colors.monotoneMidDark} !important;
        }
        .u-color-xl-monotoneDark, .u-color-xl-monotoneDark *:not(a){
            color: ${props => props.theme.colors.monotoneDark} !important;
        }
        .u-color-xl-alert, .u-color-xl-alert *:not(a){
            color: ${props => props.theme.colors.alert} !important;
        }
        .u-color-xl-accentPrimary, .u-color-xl-accentPrimary *:not(a){
            color: ${props => props.theme.colors.accentPrimary} !important;
        }
        .u-color-xl-accentSecondary, .u-color-xl-accentSecondary *:not(a){
            color: ${props => props.theme.colors.accentSecondary} !important;
        }
        .u-color-xl-accent3, .u-color-xl-accent3 *:not(a){
            color: ${props => props.theme.colors.accent3} !important;
        }
        .u-color-xl-accent4, .u-color-xl-accent4 *:not(a){
            color: ${props => props.theme.colors.accent4} !important;
        }
        .u-color-xl-brilliant, .u-color-xl-brilliant *:not(a){
            color: ${props => props.theme.colors.brilliant} !important;
        }
    `}

    ${"" /* Background Colours - responsive classes */}
    .u-bg-primary{
        background-color: ${props => props.theme.colors.primary} !important;
    }
    .u-bg-primaryTone{
        background-color: ${props => props.theme.colors.primaryTone} !important;
    }
    .u-bg-secondary{
        background-color: ${props => props.theme.colors.secondary} !important;
    }
    .u-bg-secondaryTone{
        background-color: ${props =>
            props.theme.colors.secondaryTone} !important;
    }
    .u-bg-tertiary{
        background-color: ${props => props.theme.colors.tertiary} !important;
    }
    .u-bg-monotoneMidLight{
        background-color: ${props =>
            props.theme.colors.monotoneMidLight} !important;
    }
    .u-bg-monotoneMidDark{
        background-color: ${props =>
            props.theme.colors.monotoneMidDark} !important;
    }
    .u-bg-monotoneDark{
        background-color: ${props =>
            props.theme.colors.monotoneDark} !important;
    }
    .u-bg-alert{
        background-color: ${props => props.theme.colors.alert} !important;
    }
    .u-bg-accentPrimary{
        background-color: ${props =>
            props.theme.colors.accentPrimary} !important;
    }
    .u-bg-accentSecondary{
        background-color: ${props =>
            props.theme.colors.accentSecondary} !important;
    }
    .u-bg-accent3{
        background-color: ${props => props.theme.colors.accent3} !important;
    }
    .u-bg-accent4{
        background-color: ${props => props.theme.colors.accent4} !important;
    }
    .u-bg-brilliant{
        background-color: ${props => props.theme.colors.brilliant} !important;
    }
    .u-bg-backgroundLightest{
        background-color: ${props =>
            props.theme.colors.backgroundLightest} !important;
    }
    .u-bg-backgroundLighter{
        background-color: ${props =>
            props.theme.colors.backgroundLighter} !important;
    }
    .u-bg-backgroundLight{
        background-color: ${props =>
            props.theme.colors.backgroundLight} !important;
    }
    .u-bg-backgroundLightTone{
        background-color: ${props =>
            props.theme.colors.backgroundLightTone} !important;
    }

    ${media.sm.only`
        .u-bg-sm-primary{
            background-color: ${props => props.theme.colors.primary} !important;
        }
        .u-bg-sm-primaryTone{
            background-color: ${props =>
                props.theme.colors.primaryTone} !important;
        }
        .u-bg-sm-secondary{
            background-color: ${props =>
                props.theme.colors.secondary} !important;
        }
        .u-bg-sm-secondaryTone{
            background-color: ${props =>
                props.theme.colors.secondaryTone} !important;
        }
        .u-bg-sm-tertiary{
            background-color: ${props =>
                props.theme.colors.tertiary} !important;
        }
        .u-bg-sm-monotoneMidLight{
            background-color: ${props =>
                props.theme.colors.monotoneMidLight} !important;
        }
        .u-bg-sm-monotoneMidDark{
            background-color: ${props =>
                props.theme.colors.monotoneMidDark} !important;
        }
        .u-bg-sm-monotoneDark{
            background-color: ${props =>
                props.theme.colors.monotoneDark} !important;
        }
        .u-bg-sm-alert{
            background-color: ${props => props.theme.colors.alert} !important;
        }
        .u-bg-sm-accentPrimary{
            background-color: ${props =>
                props.theme.colors.accentPrimary} !important;
        }
        .u-bg-sm-accentSecondary{
            background-color: ${props =>
                props.theme.colors.accentSecondary} !important;
        }
        .u-bg-sm-accent3{
            background-color: ${props => props.theme.colors.accent3} !important;
        }
        .u-bg-sm-accent4{
            background-color: ${props => props.theme.colors.accent4} !important;
        }
        .u-bg-sm-brilliant{
            background-color: ${props =>
                props.theme.colors.brilliant} !important;
        }
        .u-bg-sm-backgroundLightest{
            background-color: ${props =>
                props.theme.colors.backgroundLightest} !important;
        }
        .u-bg-sm-backgroundLighter{
            background-color: ${props =>
                props.theme.colors.backgroundLighter} !important;
        }
        .u-bg-sm-backgroundLight{
            background-color: ${props =>
                props.theme.colors.backgroundLight} !important;
        }
        .u-bg-sm-backgroundLightTone{
            background-color: ${props =>
                props.theme.colors.backgroundLightTone} !important;
        }
    `}
    ${media.md.only`
        .u-bg-md-primary{
            background-color: ${props => props.theme.colors.primary} !important;
        }
        .u-bg-md-primaryTone{
            background-color: ${props =>
                props.theme.colors.primaryTone} !important;
        }
        .u-bg-md-secondary{
            background-color: ${props =>
                props.theme.colors.secondary} !important;
        }
        .u-bg-md-secondaryTone{
            background-color: ${props =>
                props.theme.colors.secondaryTone} !important;
        }
        .u-bg-md-tertiary{
            background-color: ${props =>
                props.theme.colors.tertiary} !important;
        }
        .u-bg-md-monotoneMidLight{
            background-color: ${props =>
                props.theme.colors.monotoneMidLight} !important;
        }
        .u-bg-md-monotoneMidDark{
            background-color: ${props =>
                props.theme.colors.monotoneMidDark} !important;
        }
        .u-bg-md-monotoneDark{
            background-color: ${props =>
                props.theme.colors.monotoneDark} !important;
        }
        .u-bg-md-alert{
            background-color: ${props => props.theme.colors.alert} !important;
        }
        .u-bg-md-accentPrimary{
            background-color: ${props =>
                props.theme.colors.accentPrimary} !important;
        }
        .u-bg-md-accentSecondary{
            background-color: ${props =>
                props.theme.colors.accentSecondary} !important;
        }
        .u-bg-md-accent3{
            background-color: ${props => props.theme.colors.accent3} !important;
        }
        .u-bg-md-accent4{
            background-color: ${props => props.theme.colors.accent4} !important;
        }
        .u-bg-md-brilliant{
            background-color: ${props =>
                props.theme.colors.brilliant} !important;
        }
        .u-bg-md-backgroundLightest{
            background-color: ${props =>
                props.theme.colors.backgroundLightest} !important;
        }
        .u-bg-md-backgroundLighter{
            background-color: ${props =>
                props.theme.colors.backgroundLighter} !important;
        }
        .u-bg-md-backgroundLight{
            background-color: ${props =>
                props.theme.colors.backgroundLight} !important;
        }
        .u-bg-md-backgroundLightTone{
            background-color: ${props =>
                props.theme.colors.backgroundLightTone} !important;
        }
    `}
    ${media.lg.only`
        .u-bg-lg-primary{
            background-color: ${props => props.theme.colors.primary} !important;
        }
        .u-bg-lg-primaryTone{
            background-color: ${props =>
                props.theme.colors.primaryTone} !important;
        }
        .u-bg-lg-secondary{
            background-color: ${props =>
                props.theme.colors.secondary} !important;
        }
        .u-bg-lg-secondaryTone{
            background-color: ${props =>
                props.theme.colors.secondaryTone} !important;
        }
        .u-bg-lg-tertiary{
            background-color: ${props =>
                props.theme.colors.tertiary} !important;
        }
        .u-bg-lg-monotoneMidLight{
            background-color: ${props =>
                props.theme.colors.monotoneMidLight} !important;
        }
        .u-bg-lg-monotoneMidDark{
            background-color: ${props =>
                props.theme.colors.monotoneMidDark} !important;
        }
        .u-bg-lg-monotoneDark{
            background-color: ${props =>
                props.theme.colors.monotoneDark} !important;
        }
        .u-bg-lg-alert{
            background-color: ${props => props.theme.colors.alert} !important;
        }
        .u-bg-lg-accentPrimary{
            background-color: ${props =>
                props.theme.colors.accentPrimary} !important;
        }
        .u-bg-lg-accentSecondary{
            background-color: ${props =>
                props.theme.colors.accentSecondary} !important;
        }
        .u-bg-lg-accent3{
            background-color: ${props => props.theme.colors.accent3} !important;
        }
        .u-bg-lg-accent4{
            background-color: ${props => props.theme.colors.accent4} !important;
        }
        .u-bg-lg-brilliant{
            background-color: ${props =>
                props.theme.colors.brilliant} !important;
        }
        .u-bg-lg-backgroundLightest{
            background-color: ${props =>
                props.theme.colors.backgroundLightest} !important;
        }
        .u-bg-lg-backgroundLighter{
            background-color: ${props =>
                props.theme.colors.backgroundLighter} !important;
        }
        .u-bg-lg-backgroundLight{
            background-color: ${props =>
                props.theme.colors.backgroundLight} !important;
        }
        .u-bg-lg-backgroundLightTone{
            background-color: ${props =>
                props.theme.colors.backgroundLightTone} !important;
        }
    `}
    ${media.xl.only`
        .u-bg-xl-primary{
            background-color: ${props => props.theme.colors.primary} !important;
        }
        .u-bg-xl-primaryTone{
            background-color: ${props =>
                props.theme.colors.primaryTone} !important;
        }
        .u-bg-xl-secondary{
            background-color: ${props =>
                props.theme.colors.secondary} !important;
        }
        .u-bg-xl-secondaryTone{
            background-color: ${props =>
                props.theme.colors.secondaryTone} !important;
        }
        .u-bg-xl-tertiary{
            background-color: ${props =>
                props.theme.colors.tertiary} !important;
        }
        .u-bg-xl-monotoneMidLight{
            background-color: ${props =>
                props.theme.colors.monotoneMidLight} !important;
        }
        .u-bg-xl-monotoneMidDark{
            background-color: ${props =>
                props.theme.colors.monotoneMidDark} !important;
        }
        .u-bg-xl-monotoneDark{
            background-color: ${props =>
                props.theme.colors.monotoneDark} !important;
        }
        .u-bg-xl-alert{
            background-color: ${props => props.theme.colors.alert} !important;
        }
        .u-bg-xl-accentPrimary{
            background-color: ${props =>
                props.theme.colors.accentPrimary} !important;
        }
        .u-bg-xl-accentSecondary{
            background-color: ${props =>
                props.theme.colors.accentSecondary} !important;
        }
        .u-bg-xl-accent3{
            background-color: ${props => props.theme.colors.accent3} !important;
        }
        .u-bg-xl-accent4{
            background-color: ${props => props.theme.colors.accent4} !important;
        }
        .u-bg-xl-brilliant{
            background-color: ${props =>
                props.theme.colors.brilliant} !important;
        }
        .u-bg-xl-backgroundLightest{
            background-color: ${props =>
                props.theme.colors.backgroundLightest} !important;
        }
        .u-bg-xl-backgroundLighter{
            background-color: ${props =>
                props.theme.colors.backgroundLighter} !important;
        }
        .u-bg-xl-backgroundLight{
            background-color: ${props =>
                props.theme.colors.backgroundLight} !important;
        }
        .u-bg-xl-backgroundLightTone{
            background-color: ${props =>
                props.theme.colors.backgroundLightTone} !important;
        }
    `}

    ${"" /* Border Utilities */}

    .u-border{
        border: 1px solid;
    }

    ${"" /* Border Colours */}

    .u-border-color-primary{
        border-color: ${props => props.theme.colors.primary} !important;
    }
    .u-border-color-primaryTone{
        border-color: ${props => props.theme.colors.primaryTone} !important;
    }
    .u-border-color-secondary{
        border-color: ${props => props.theme.colors.secondary} !important;
    }
    .u-border-color-secondaryTone{
        border-color: ${props => props.theme.colors.secondaryTone} !important;
    }
    .u-border-color-tertiary{
        border-color: ${props => props.theme.colors.tertiary} !important;
    }
    .u-border-color-monotoneMid{
        border-color: ${props => props.theme.colors.monotoneMid} !important;
    }
    .u-border-color-monotoneMidLight{
        border-color: ${props =>
            props.theme.colors.monotoneMidLight} !important;
    }
    .u-border-color-monotoneMidDark{
        border-color: ${props => props.theme.colors.monotoneMidDark} !important;
    }
    .u-border-color-monotoneDark{
        border-color: ${props => props.theme.colors.monotoneDark} !important;
    }
    .u-border-color-alert{
        border-color: ${props => props.theme.colors.alert} !important;
    }
    .u-border-color-accentPrimary{
        border-color: ${props => props.theme.colors.accentPrimary} !important;
    }
    .u-border-color-accentSecondary{
        border-color: ${props => props.theme.colors.accentSecondary} !important;
    }
    .u-border-color-accent3{
        border-color: ${props => props.theme.colors.accent3} !important;
    }
    .u-border-color-accent4{
        border-color: ${props => props.theme.colors.accent4} !important;
    }
    .u-border-color-brilliant{
        border-color: ${props => props.theme.colors.brilliant} !important;
    }
    .u-border-color-backgroundLightest{
        border-color: ${props =>
            props.theme.colors.backgroundLightest} !important;
    }
    .u-border-color-backgroundLighter{
        border-color: ${props =>
            props.theme.colors.backgroundLighter} !important;
    }
    .u-border-color-backgroundLight{
        border-color: ${props => props.theme.colors.backgroundLight} !important;
    }
    .u-border-color-backgroundLightTone{
        border-color: ${props =>
            props.theme.colors.backgroundLightTone} !important;
    }

    ${"" /* Border Radius */}
    .u-border-radius{
        border-radius: ${props => props.theme.radii[0]} !important;
    }
    .u-border-radius-double{
        border-radius: calc(${props => props.theme.radii[0]}*2) !important;
    }

    ${"" /* Line height Utilities */}
    .u-line-height-12, .u-line-height-12 *{
        line-height: ${props => props.theme.lineHeights[0]} !important;
    }
    .u-line-height-14, .u-line-height-14 *{
        line-height: ${props => props.theme.lineHeights[1]} !important;
    }
    .u-line-height-16, .u-line-height-16 *{
        line-height: ${props => props.theme.lineHeights[2]} !important;
    }
    .u-line-height-18, .u-line-height-18 *{
        line-height: ${props => props.theme.lineHeights[3]} !important;
    }
    .u-line-height-20, .u-line-height-20 *{
        line-height: ${props => props.theme.lineHeights[4]} !important;
    }
    .u-line-height-24, .u-line-height-24 *{
        line-height: ${props => props.theme.lineHeights[5]} !important;
    }
    .u-line-height-24, .u-line-height-24 *{
        line-height: ${props => props.theme.lineHeights[6]} !important;
    }
    .u-line-height-32, .u-line-height-32 *{
        line-height: ${props => props.theme.lineHeights[7]} !important;
    }
    .u-line-height-48, .u-line-height-48 *{
        line-height: ${props => props.theme.lineHeights[8]} !important;
    }
    .u-line-height-64, .u-line-height-64 *{
        line-height: ${props => props.theme.lineHeights[9]} !important;
    }

    ${"" /* Font Size Utilities */}
    .u-font-size-12, .u-font-size-12 *{
        font-size: ${props => props.theme.fontSizes[0]} !important;
    }
    .u-font-size-14, .u-font-size-14 *{
        font-size: ${props => props.theme.fontSizes[1]} !important;
    }
    .u-font-size-16, .u-font-size-16 *{
        font-size: ${props => props.theme.fontSizes[2]} !important;
    }
    .u-font-size-18, .u-font-size-18 *{
        font-size: ${props => props.theme.fontSizes[3]} !important;
    }
    .u-font-size-20, .u-font-size-20 *{
        font-size: ${props => props.theme.fontSizes[4]} !important;
    }
    .u-font-size-24, .u-font-size-24 *{
        font-size: ${props => props.theme.fontSizes[5]} !important;
    }
    .u-font-size-28, .u-font-size-28 *{
        font-size: ${props => props.theme.fontSizes[6]} !important;
    }
    .u-font-size-32, .u-font-size-32 *{
        font-size: ${props => props.theme.fontSizes[7]} !important;
    }
    .u-font-size-48, .u-font-size-48 *{
        font-size: ${props => props.theme.fontSizes[8]} !important;
    }
    .u-font-size-64, .u-font-size-64 *{
        font-size: ${props => props.theme.fontSizes[8]} !important;
    }
    ${media.sm.down`
        .u-font-size-sm-12, .u-font-size-sm-12 *{
            font-size: ${props => props.theme.fontSizes[0]} !important;
        }
        .u-font-size-sm-14, .u-font-size-sm-14 *{
            font-size: ${props => props.theme.fontSizes[1]} !important;
        }
        .u-font-size-sm-16, .u-font-size-sm-16 *{
            font-size: ${props => props.theme.fontSizes[2]} !important;
        }
        .u-font-size-sm-18, .u-font-size-sm-18 *{
            font-size: ${props => props.theme.fontSizes[3]} !important;
        }
        .u-font-size-sm-20, .u-font-size-sm-20 *{
            font-size: ${props => props.theme.fontSizes[4]} !important;
        }
        .u-font-size-sm-24, .u-font-size-sm-24 *{
            font-size: ${props => props.theme.fontSizes[5]} !important;
        }
        .u-font-size-sm-28, .u-font-size-sm-28 *{
            font-size: ${props => props.theme.fontSizes[6]} !important;
        }
        .u-font-size-sm-32, .u-font-size-sm-32 *{
            font-size: ${props => props.theme.fontSizes[7]} !important;
        }
        .u-font-size-sm-48, .u-font-size-sm-48 *{
            font-size: ${props => props.theme.fontSizes[8]} !important;
        }
        .u-font-size-sm-64, .u-font-size-sm-64 *{
            font-size: ${props => props.theme.fontSizes[8]} !important;
        }
    `}
    ${media.xs.down`
        .u-font-size-xs-12, .u-font-size-xs-12 *{
            font-size: ${props => props.theme.fontSizes[0]} !important;
        }
        .u-font-size-xs-14, .u-font-size-xs-14 *{
            font-size: ${props => props.theme.fontSizes[1]} !important;
        }
        .u-font-size-xs-16, .u-font-size-xs-16 *{
            font-size: ${props => props.theme.fontSizes[2]} !important;
        }
        .u-font-size-xs-18, .u-font-size-xs-18 *{
            font-size: ${props => props.theme.fontSizes[3]} !important;
        }
        .u-font-size-xs-20, .u-font-size-xs-20 *{
            font-size: ${props => props.theme.fontSizes[4]} !important;
        }
        .u-font-size-xs-24, .u-font-size-xs-24 *{
            font-size: ${props => props.theme.fontSizes[5]} !important;
        }
        .u-font-size-xs-28, .u-font-size-xs-28 *{
            font-size: ${props => props.theme.fontSizes[6]} !important;
        }
        .u-font-size-xs-32, .u-font-size-xs-32 *{
            font-size: ${props => props.theme.fontSizes[7]} !important;
        }
        .u-font-size-xs-48, .u-font-size-xs-48 *{
            font-size: ${props => props.theme.fontSizes[8]} !important;
        }
        .u-font-size-xs-64, .u-font-size-xs-64 *{
            font-size: ${props => props.theme.fontSizes[8]} !important;
        }
    `}

    ${"" /* Font Weight Utilities */}
    .u-font-weight-light, .u-font-weight-light *{
        font-weight: ${props => props.theme.fontWeights.light} !important;
    }
    .u-font-weight-regular, .u-font-weight-regular *{
        font-weight: ${props => props.theme.fontWeights.regular} !important;
    }
    .u-font-weight-semibold, .u-font-weight-semibold *{
        font-weight: ${props => props.theme.fontWeights.semiBold} !important;
    }
    .u-font-weight-bold, .u-font-weight-bold *{
        font-weight: ${props => props.theme.fontWeights.bold} !important;
    }

    ${"" /* Grid Template Column Utilities */}
    .u-grid-col-2 {
        grid-template-columns: 1fr 1fr;
    }
    ${media.md.up`
        .u-grid-col-md-2 {
            grid-template-columns: 1fr 1fr;
        }
    `}


    ${"" /* Fade transition styles */}

    .fade-enter, .fade-appear {
        opacity: 0;
    }
    .fade-enter-active, .fade-appear-active {
        opacity: 1;
        transition: opacity 200ms;
    }
    .fade-exit {
        opacity: 1;
    }
    .fade-exit-active {
        opacity: 0;
        transition: opacity 200ms;
    }


    ${"" /* Datepicker - BOI style overrides */}
    .boi-datepicker + .react-datepicker__close-icon{
        right: ${props => props.theme.space[1]};
        &:after{
            background: none;
            color: ${props => props.theme.colors.monotoneMid};
            font-size: ${remCalc(33)};
        }
    }
    .react-datepicker{
        &-popper{
            z-index: 3;
        }
        &-popper[data-placement="bottom-start"]{
            .boi-calendar-error{
                top: ${props => props.theme.space[5]};
            }
        }
        &-popper[data-placement="top-start"]{
            .boi-calendar-error{
                top: -${props => props.theme.space[8]};
            }
        }
        &__tab-loop div{
            outline: none;
        }
        &.boi-calendar{
            top: -${props => props.theme.space[2]};
            font-size: ${props => props.theme.fontSizes[0]};
            box-shadow: 1px 1px 16px 0 rgba(0,0,0,0.2);
            border: 1px solid ${props => props.theme.colors.monotoneMidLight};
            padding: ${props => props.theme.space[0]};
            .react-datepicker__navigation{
                top: ${props => props.theme.space[5]};
                &.react-datepicker__navigation--previous, &.react-datepicker__navigation--next{
                    border: none;
                    background-repeat: no-repeat;
                    width: ${props => props.theme.space[7]};
                    height: ${props => props.theme.space[5]};
                    span{
                        display: none;
                    }

                }
                &.react-datepicker__navigation--previous{
                    background-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNMTAuNzgwMDAwNiwwLjE0MzgzNzQ3IEwxOS43Mzg5MzU2LDguMDM0NTE0MSBDMTkuODIxODY0LDguMDc5NzEyIDE5Ljg5MDU3ODQsOC4xNDc3MDYzIDE5LjkzNjY2MDEsOC4yMzAwNzg1IEMxOS45OTc4ODk5LDguMzE0NDg2MSAyMC4wMzA5MzIsOC40MTczNzk1IDIwLjAzMDAzOCw4LjUyMzgzNzUgQzIwLjAzMTA0NTEsOC42NjYyODY1IDE5Ljk2ODc2MzUsOC44MDE4NDA1IDE5Ljg2MDAwMDYsOC44OTM4Mzc1IEwxMC43ODAwMDA2LDE2Ljg5MzgzNzUgQzEwLjY4MzQyMiwxNi45NTk4MjA4IDEwLjU2NjA3MzcsMTYuOTg4MjY4OCAxMC40NTAwMDA2LDE2Ljk3MzgzNzUgQzEwLjMwNTE4NzksMTYuOTcyNTU3NCAxMC4xNjc0Njg4LDE2LjkxMDk0NjMgMTAuMDcwMDAwNiwxNi44MDM4Mzc1IEM5Ljg5MTQ2NjMsMTYuNTkyNzQwMiA5LjkxMzY0MzEsMTYuMjc3ODI5NyAxMC4xMjAwMDA2LDE2LjA5MzgzNzUgTDE4LjIwMjAwMDYsOC45NzMgTDAuNTAwMDAwNTk4LDguOTczODM3NSBDMC4yMjM4NTgyMjgsOC45NzM4Mzc1IDUuOTc5OTAyODdlLTA3LDguNzQ5OTc5OCA1Ljk3OTkwMjg3ZS0wNyw4LjQ3MzgzNzUgQzUuOTc5OTAyODdlLTA3LDguMTk3Njk1MSAwLjIyMzg1ODIyOCw3Ljk3MzgzNzUgMC41MDAwMDA1OTgsNy45NzM4Mzc1IEwxOC4yMDMwMDA2LDcuOTczIEwxMC4xMjAwMDA2LDAuODQzODM3NDcgQzEwLjAxOTA0OTUsMC43NTg1ODU5OSA5Ljk1NjgwNjgsMC42MzYxNzc0MSA5Ljk0NzM5MjgsMC41MDQzODA4OSBDOS45Mzc5Nzg3LDAuMzcyNTg0MzYgOS45ODIxOTEzLDAuMjQyNTcxODMgMTAuMDcwMDAwNiwwLjE0MzgzNzQ3IEMxMC4yNjc4MTQzLC0wLjA0Nzk0NTgyIDEwLjU4MjE4NjksLTAuMDQ3OTQ1ODIgMTAuNzgwMDAwNiwwLjE0MzgzNzQ3IFoiIGlkPSJtYXNrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMC4wMTUwMTksIDguNDg4NzUzKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMC4wMTUwMTksIC04LjQ4ODc1MykiPjwvcGF0aD48L3N2Zz4=");
                    left: ${props => props.theme.space[4]};
                }
                &.react-datepicker__navigation--next{
                    background-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNMTAuNzgwMDAwNiwwLjE0MzgzNzQ3IEwxOS43Mzg5MzU2LDguMDM0NTE0MSBDMTkuODIxODY0LDguMDc5NzEyIDE5Ljg5MDU3ODQsOC4xNDc3MDYzIDE5LjkzNjY2MDEsOC4yMzAwNzg1IEMxOS45OTc4ODk5LDguMzE0NDg2MSAyMC4wMzA5MzIsOC40MTczNzk1IDIwLjAzMDAzOCw4LjUyMzgzNzUgQzIwLjAzMTA0NTEsOC42NjYyODY1IDE5Ljk2ODc2MzUsOC44MDE4NDA1IDE5Ljg2MDAwMDYsOC44OTM4Mzc1IEwxMC43ODAwMDA2LDE2Ljg5MzgzNzUgQzEwLjY4MzQyMiwxNi45NTk4MjA4IDEwLjU2NjA3MzcsMTYuOTg4MjY4OCAxMC40NTAwMDA2LDE2Ljk3MzgzNzUgQzEwLjMwNTE4NzksMTYuOTcyNTU3NCAxMC4xNjc0Njg4LDE2LjkxMDk0NjMgMTAuMDcwMDAwNiwxNi44MDM4Mzc1IEM5Ljg5MTQ2NjMsMTYuNTkyNzQwMiA5LjkxMzY0MzEsMTYuMjc3ODI5NyAxMC4xMjAwMDA2LDE2LjA5MzgzNzUgTDE4LjIwMjAwMDYsOC45NzMgTDAuNTAwMDAwNTk4LDguOTczODM3NSBDMC4yMjM4NTgyMjgsOC45NzM4Mzc1IDUuOTc5OTAyODdlLTA3LDguNzQ5OTc5OCA1Ljk3OTkwMjg3ZS0wNyw4LjQ3MzgzNzUgQzUuOTc5OTAyODdlLTA3LDguMTk3Njk1MSAwLjIyMzg1ODIyOCw3Ljk3MzgzNzUgMC41MDAwMDA1OTgsNy45NzM4Mzc1IEwxOC4yMDMwMDA2LDcuOTczIEwxMC4xMjAwMDA2LDAuODQzODM3NDcgQzEwLjAxOTA0OTUsMC43NTg1ODU5OSA5Ljk1NjgwNjgsMC42MzYxNzc0MSA5Ljk0NzM5MjgsMC41MDQzODA4OSBDOS45Mzc5Nzg3LDAuMzcyNTg0MzYgOS45ODIxOTEzLDAuMjQyNTcxODMgMTAuMDcwMDAwNiwwLjE0MzgzNzQ3IEMxMC4yNjc4MTQzLC0wLjA0Nzk0NTgyIDEwLjU4MjE4NjksLTAuMDQ3OTQ1ODIgMTAuNzgwMDAwNiwwLjE0MzgzNzQ3IFoiIGlkPSJtYXNrIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMC4wMTUwMTksIDguNDg4NzUzKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0xMC4wMTUwMTksIC04LjQ4ODc1MykiPjwvcGF0aD48L3N2Zz4=");
                    transform: rotate(180deg);
                    right: ${props => props.theme.space[4]};
                }
            }
            .react-datepicker__header__dropdown{
                padding-bottom: ${props => props.theme.space[5]};
                &.react-datepicker__header__dropdown--select{
                    select{
                        background-color: transparent;
                        border: none;
                        color: ${props => props.theme.colors.brilliant};
                        font-weight: ${props =>
                            props.theme.fontWeights.semiBold};
                        font-size: ${props => props.theme.fontSizes[2]};
                        &.react-datepicker__month-select{
                            margin-right: ${props => props.theme.space[2]};
                        }
                        &:focus, &:focus-visible{
                            outline: none;
                        }
                        option{
                            color: ${props => props.theme.colors.monotoneDark};
                        }
                        option:hover{
                            background: ${props =>
                                props.theme.colors.monotoneMidLight};
                        }
                        option:checked, option:hover:checked{
                            color: ${props => props.theme.colors.brilliant};
                            background: ${props => props.theme.colors.primary};
                            outline-fill: ${props =>
                                props.theme.colors.primary};
                        }
                    }
                    .react-datepicker__year-dropdown-container--select, .react-datepicker__month-dropdown-container--select, .react-datepicker__month-year-dropdown-container--select{
                        margin: 0 ${props => props.theme.space[1]};
                    }
                }
                &.react-datepicker__header__dropdown--scroll{
                    .react-datepicker__year-dropdown-container--scroll, .react-datepicker__month-dropdown-container--scroll, .react-datepicker__month-year-dropdown-container--scroll{
                        padding: 0 ${props => props.theme.space[2]};
                    }
                    .react-datepicker__year-dropdown--scrollable, .react-datepicker__month-dropdown--scrollable, .react-datepicker__month-year-dropdown--scrollable{
                        height: auto;
                        max-height: ${remCalc(150)};
                    }
                    .react-datepicker__year-read-view, .react-datepicker__month-read-view{
                        color: ${props => props.theme.colors.brilliant};
                        font-weight: ${props =>
                            props.theme.fontWeights.semiBold};
                        display: inline;
                        .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow{
                            border: none;
                            width: ${remCalc(12)};
                            height: ${remCalc(12)};
                            padding: 0;
                            margin: 0;
                            top: ${remCalc(6.4)};
                            color: ${props => props.theme.colors.brilliant};
                            background: url("data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-down-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
                            background-size: cover;
                            margin-left: ${props => props.theme.space[2]};
                            transform: rotate(0deg);
                        }
                    }
                    .react-datepicker__year-dropdown, .react-datepicker__month-dropdown, .react-datepicker__month-year-dropdown{
                        top: ${props => props.theme.space[2]};
                        background-color: ${props =>
                            props.theme.colors.backgroundLighter};
                        border-width: 0;
                    }
                    .react-datepicker__year-option, .react-datepicker__month-option, .react-datepicker__month-year-option{
                        line-height: ${remCalc(28)};
                    }
                    .react-datepicker__navigation--years-previous, .react-datepicker__navigation--years-upcoming{
                        border: none;
                        width: ${props => props.theme.space[4]};
                        height: ${props => props.theme.space[4]};
                        top: 0;
                    }
                    .react-datepicker__navigation--years-previous{
                        background: url("data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-down-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
                    }
                    .react-datepicker__navigation--years-upcoming{
                        background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-up-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M1.32407298,9.65373497 L6.38590162,4.58653639 C7.12544999,3.84620345 8.30091334,3.80663601 9.08705166,4.46827159 L9.21606934,4.58677818 L9.21606934,4.58677818 L14.275927,9.65373497 C14.7080243,10.0864016 14.7080243,10.7871995 14.275927,11.2204201 C13.8438297,11.6530867 13.1434005,11.6530867 12.7113032,11.2204201 L8.15481288,6.65792676 C7.98136083,6.48424619 7.71194918,6.46478368 7.51699221,6.59965142 L7.44732038,6.65784706 L7.44732038,6.65784706 L2.88869678,11.2204201 C2.45659948,11.6530867 1.75617029,11.6530867 1.32407298,11.2204201 C0.891975673,10.7871995 0.891975673,10.0864016 1.32407298,9.65373497 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
                    }
                    .react-datepicker__year-option:hover, .react-datepicker__month-option:hover, .react-datepicker__month-year-option:hover{
                        background: ${props => props.theme.colors.primaryTone};
                        color: ${props => props.theme.colors.brilliant};
                        .react-datepicker__navigation--years-previous{
                            background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='chevron-down-white' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                        }
                        .react-datepicker__navigation--years-upcoming{
                            background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='chevron-up-white' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M1.32407298,9.65373497 L6.38590162,4.58653639 C7.12544999,3.84620345 8.30091334,3.80663601 9.08705166,4.46827159 L9.21606934,4.58677818 L9.21606934,4.58677818 L14.275927,9.65373497 C14.7080243,10.0864016 14.7080243,10.7871995 14.275927,11.2204201 C13.8438297,11.6530867 13.1434005,11.6530867 12.7113032,11.2204201 L8.15481288,6.65792676 C7.98136083,6.48424619 7.71194918,6.46478368 7.51699221,6.59965142 L7.44732038,6.65784706 L7.44732038,6.65784706 L2.88869678,11.2204201 C2.45659948,11.6530867 1.75617029,11.6530867 1.32407298,11.2204201 C0.891975673,10.7871995 0.891975673,10.0864016 1.32407298,9.65373497 Z' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                        }
                    }
                }
            }
            .react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header{
                color: ${props => props.theme.colors.brilliant};
                font-weight: ${props => props.theme.fontWeights.light};
                font-size: ${props => props.theme.fontSizes[2]};
            }
            .react-datepicker__header{
                font-size: ${remCalc(16)};
                padding-top: ${props => props.theme.space[5]};
                border-bottom: 0;
                background-color: ${props => props.theme.colors.primary};
            }
            .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected{
                background-color: ${props => props.theme.colors.primary};
                border-bottom: 0;
            }
            .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{
                margin: 0;
                padding: ${props => props.theme.space[2]};
                border-right: 1px solid transparent;
                &:last-child{
                    border-right: 0;
                }
            }
            .react-datepicker__day-names{
                font-size: ${remCalc(12)};
                font-weight: ${props => props.theme.fontWeights.semiBold};
                background-color: ${props => props.theme.colors.brilliant};
                padding-top: ${remCalc(16)};
                .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{
                }
            }
            .react-datepicker__week{
                background-color: ${props => props.theme.colors.brilliant};
                .react-datepicker__day{
                    &.react-datepicker__day--selected, &.react-datepicker__day--selected:hover{
                        color: ${props => props.theme.colors.brilliant};
                        background-color: ${props =>
                            props.theme.colors.primary};
                        border-radius: 0;
                    }
                    &.react-datepicker__day--keyboard-selected{
                        background: inherit;
                        &:not(.react-datepicker__day--disabled){
                            color: ${props => props.theme.colors.monotoneDark};
                            &:focus {
                                outline: 1px dotted black;
                            }
                        }
                    }
                    &:hover{
                        background-color: ${props =>
                            props.theme.colors.monotoneMidLight};
                    }
                }
            }
            .react-datepicker__month{
                margin: ${props => props.theme.space[2]};
                .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{
                    border-color: transparent;
                }
            }
            .react-datepicker__day:hover, .react-datepicker__month-text:hover, .react-datepicker__quarter-text:hover{
                border-radius: 0;
            }
            .react-datepicker__day-names, .react-datepicker__week{
                border-bottom: transparent;
            }
            .react-datepicker__year-dropdown, .react-datepicker__month-dropdown, .react-datepicker__month-year-dropdown{
                top: 0;
                background-color: ${props =>
                    props.theme.colors.backgroundLighter};
                border-color: ${props => props.theme.colors.monotoneMidLight};
            }
            .react-datepicker__year-option, .react-datepicker__month-option, .react-datepicker__month-year-option{
                line-height: ${remCalc(24)};
            }
            .react-datepicker__navigation--years-previous, .react-datepicker__navigation--years-upcoming{
                border: none;
                width: ${props => props.theme.space[4]}; 
                height: ${props => props.theme.space[4]};
                top: 0;
            }
            .react-datepicker__navigation--years-previous{
                background: url("data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-down-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
            }
            .react-datepicker__navigation--years-upcoming{
                background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-up-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M1.32407298,9.65373497 L6.38590162,4.58653639 C7.12544999,3.84620345 8.30091334,3.80663601 9.08705166,4.46827159 L9.21606934,4.58677818 L9.21606934,4.58677818 L14.275927,9.65373497 C14.7080243,10.0864016 14.7080243,10.7871995 14.275927,11.2204201 C13.8438297,11.6530867 13.1434005,11.6530867 12.7113032,11.2204201 L8.15481288,6.65792676 C7.98136083,6.48424619 7.71194918,6.46478368 7.51699221,6.59965142 L7.44732038,6.65784706 L7.44732038,6.65784706 L2.88869678,11.2204201 C2.45659948,11.6530867 1.75617029,11.6530867 1.32407298,11.2204201 C0.891975673,10.7871995 0.891975673,10.0864016 1.32407298,9.65373497 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
            }
            .react-datepicker__year-option:hover, .react-datepicker__month-option:hover, .react-datepicker__month-year-option:hover{
                background: ${props => props.theme.colors.primary};
                color: ${props => props.theme.colors.brilliant};
                .react-datepicker__navigation--years-previous{
                    background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='chevron-down-white' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                }
                .react-datepicker__navigation--years-upcoming{
                    background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='chevron-up-white' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M1.32407298,9.65373497 L6.38590162,4.58653639 C7.12544999,3.84620345 8.30091334,3.80663601 9.08705166,4.46827159 L9.21606934,4.58677818 L9.21606934,4.58677818 L14.275927,9.65373497 C14.7080243,10.0864016 14.7080243,10.7871995 14.275927,11.2204201 C13.8438297,11.6530867 13.1434005,11.6530867 12.7113032,11.2204201 L8.15481288,6.65792676 C7.98136083,6.48424619 7.71194918,6.46478368 7.51699221,6.59965142 L7.44732038,6.65784706 L7.44732038,6.65784706 L2.88869678,11.2204201 C2.45659948,11.6530867 1.75617029,11.6530867 1.32407298,11.2204201 C0.891975673,10.7871995 0.891975673,10.0864016 1.32407298,9.65373497 Z' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                }
            }
            .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow{
                border: none;
                width: ${remCalc(12)};
                height: ${remCalc(12)};
                padding: 0;
                margin: 0;
                top: ${remCalc(4)};
                background: url("data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-down-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
                background-size: cover;
                margin-left: ${props => props.theme.space[1]};
            }
            .react-datepicker__year-dropdown-container--select, .react-datepicker__month-dropdown-container--select, .react-datepicker__month-year-dropdown-container--select, .react-datepicker__year-dropdown-container--scroll, .react-datepicker__month-dropdown-container--scroll, .react-datepicker__month-year-dropdown-container--scroll{
                margin: 0 ${props => props.theme.space[1]};
            }
            .react-datepicker__year-dropdown, .react-datepicker__month-dropdown, .react-datepicker__month-year-dropdown{
                top: 0;
                background-color: ${props =>
                    props.theme.colors.backgroundLighter};
                border-color: ${props => props.theme.colors.monotoneMidLight};
            }
            .react-datepicker__year-option, .react-datepicker__month-option, .react-datepicker__month-year-option{
                line-height: ${remCalc(24)};
            }
            .react-datepicker__navigation--years-previous, .react-datepicker__navigation--years-upcoming{
                border: none;
                width: ${props => props.theme.space[4]}; 
                height: ${props => props.theme.space[4]};
                top: 0;
            }
            .react-datepicker__navigation--years-previous{
                background: url("data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-down-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
            }
            .react-datepicker__navigation--years-upcoming{
                background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-up-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M1.32407298,9.65373497 L6.38590162,4.58653639 C7.12544999,3.84620345 8.30091334,3.80663601 9.08705166,4.46827159 L9.21606934,4.58677818 L9.21606934,4.58677818 L14.275927,9.65373497 C14.7080243,10.0864016 14.7080243,10.7871995 14.275927,11.2204201 C13.8438297,11.6530867 13.1434005,11.6530867 12.7113032,11.2204201 L8.15481288,6.65792676 C7.98136083,6.48424619 7.71194918,6.46478368 7.51699221,6.59965142 L7.44732038,6.65784706 L7.44732038,6.65784706 L2.88869678,11.2204201 C2.45659948,11.6530867 1.75617029,11.6530867 1.32407298,11.2204201 C0.891975673,10.7871995 0.891975673,10.0864016 1.32407298,9.65373497 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
            }
            .react-datepicker__year-option:hover, .react-datepicker__month-option:hover, .react-datepicker__month-year-option:hover{
                background: ${props => props.theme.colors.primary};
                color: ${props => props.theme.colors.brilliant};
                .react-datepicker__navigation--years-previous{
                    background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='chevron-down-white' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                }
                .react-datepicker__navigation--years-upcoming{
                    background: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='chevron-up-white' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M1.32407298,9.65373497 L6.38590162,4.58653639 C7.12544999,3.84620345 8.30091334,3.80663601 9.08705166,4.46827159 L9.21606934,4.58677818 L9.21606934,4.58677818 L14.275927,9.65373497 C14.7080243,10.0864016 14.7080243,10.7871995 14.275927,11.2204201 C13.8438297,11.6530867 13.1434005,11.6530867 12.7113032,11.2204201 L8.15481288,6.65792676 C7.98136083,6.48424619 7.71194918,6.46478368 7.51699221,6.59965142 L7.44732038,6.65784706 L7.44732038,6.65784706 L2.88869678,11.2204201 C2.45659948,11.6530867 1.75617029,11.6530867 1.32407298,11.2204201 C0.891975673,10.7871995 0.891975673,10.0864016 1.32407298,9.65373497 Z' fill='%23FFFFFF' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
                }
            }
            .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow{
                border: none;
                width: ${remCalc(12)};
                height: ${remCalc(12)};
                padding: 0;
                margin: 0;
                top: ${remCalc(4)};
                background: url("data:image/svg+xml,%3Csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-down-mid-dark-grey' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M14.275927,5.89118508 L9.21409838,10.9583837 C8.43346399,11.7398462 7.16713421,11.7405176 6.38567166,10.9598832 C6.38509097,10.9593031 6.38451063,10.9587227 6.38393066,10.9581419 L1.32407298,5.89118508 L1.32407298,5.89118508 C0.891975673,5.45851849 0.891975673,4.75772051 1.32407298,4.32449994 C1.75617029,3.89183335 2.45659948,3.89183335 2.88869678,4.32449994 L7.44518712,8.88699329 C7.64032068,9.08238393 7.9569031,9.08259234 8.15229375,8.88745878 C8.15242244,8.88733025 8.15255107,8.88720165 8.15267962,8.88707299 L12.7113032,4.32449994 L12.7113032,4.32449994 C13.1434005,3.89183335 13.8438297,3.89183335 14.275927,4.32449994 C14.7080243,4.75772051 14.7080243,5.45851849 14.275927,5.89118508 Z' fill='%23616365' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");
                background-size: cover;
                margin-left: ${props => props.theme.space[1]};
            }
            .react-datepicker__year-dropdown-container--select, .react-datepicker__month-dropdown-container--select, .react-datepicker__month-year-dropdown-container--select, .react-datepicker__year-dropdown-container--scroll, .react-datepicker__month-dropdown-container--scroll, .react-datepicker__month-year-dropdown-container--scroll{
                margin: 0 ${props => props.theme.space[1]};
            }
        }
        &.boi-date-range-calendar{
            .react-datepicker__week{
                background-color: ${props => props.theme.colors.brilliant};
                .react-datepicker__day{
                        border-radius: 0;
                        border: 1px solid white;
                    &.react-datepicker__day--in-range, &.react-datepicker__day--in-selecting-range{
                        background-color: ${props =>
                            props.theme.colors.monotoneMidLight};
                        color: inherit;
                    }
                    &.react-datepicker__day--range-start.react-datepicker__day--in-range, &.react-datepicker__day--in-selecting-range.react-datepicker__day--selecting-range-start, &.react-datepicker__day--range-end{
                        color: ${props => props.theme.colors.brilliant};
                        background-color: ${props =>
                            props.theme.colors.primary};
                    }
                    &.react-datepicker__day--keyboard-selected{
                        &:focus {
                            outline: none;
                        }
                    }
                }
            }
        }
    }
    ${"" /* react-modal - BOI style overrides */}
    .ReactModal__Body--open{
        overflow: hidden;
    }
    .ReactModal__Overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        overflow: auto;
        border-radius: 0;
        opacity: 0;
        transition: opacity 300ms ease-in-out;
        background: white;
        &:after,
        &:before {
            display: block;
            content: none;
            height: 120px;
            ${media.sm.up`
                content: "";
            `}
        }
        &.default, &.helpLayer{
            z-index: 5;
            ${media.sm.up`
                background: rgba(73, 73, 73, 0.6);
            `}
        }
        &.fullScreen, &.fullPage, &.fullPageSidebar{
            &:before, &:after {
                background: white;
            }
        }
        &.fullScreen {
            &:before {
                height: 120px;
            }
            &:after {
                height: 84px;
            }
        }
        &.fullPage, &.fullPageSidebar{
            &:before {
                height: 36px;
            }
            &:after {
                height: 0;
            }
        }
        &.helpLayer{
            ${media.sm.up`
                background: rgba(73, 73, 73, 0.6);
            `}
            ${media.xs.down`
                margin-top: 100px;
                z-index: 3;
            `}
            &:before {
                height: 120px;
            }
            &:after {
                height: 84px;
            }
        }
        &.fullPage, &.fullPageSidebar{
            z-index: 2;  // This positions the message over everything on mobile.
            top: 59px;
            ${media.sm.up`
                z-index: 1; // This positions the message over the form & sidebar, but behind the header on all but mobile.
            `}
        }
        &.fullScreen{
            z-index: 3; // This positions the message over everything else on all screens.

        }
        .u-mt-auto{
            margin-top: unset !important;
        }
    }

    .ReactModal__Overlay--after-open{
        opacity: 1;
    }

    .ReactModal__Overlay--before-close{
        opacity: 0;
    }

    .ReactModal__Content {
        position: static !important;
        background: white;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        border-radius: 2px;
        outline: none;
        padding: 32px;
        width: calc(100% - 64px);
        max-width: 100%;
        position: static;
        margin: auto;
        min-height: calc(100% - 76px);
        border: 0;
        display: flex;
        flex-direction: column;
        ${media.sm.up`
            width: 512px;
            min-height: 480px;
            border: 1px solid rgb(204, 204, 204);
        `}
        &.helpLayer{
            justify-content: space-between;
        }
        &.fullPage, &.fullScreen, &.fullPageSidebar{
            border: 0;
            ${media.sm.up`
                min-height: calc(100% - 268px);
            `}
        }
        .block button {
            width: 100%;
        }
    }
    ${"" /* react-modal - BOI style fullPage overrides */}
    .modalRenderer{
        .ReactModalPortal{
            .ReactModal__Overlay{
                position: absolute;
                height: auto;
                min-height: 536px;
                .ReactModal__Content{
                    &.fullPage, &.fullPageSidebar{
                        box-sizing: border-box;
                        justify-content: flex-start;
                    }
                }
                &:before, &:after{
                    display: none;
                }
            }
        }
    }

    ${"" /* terms-of-service */}
    .terms-of-service{
        height: 17rem !important;
        margin-bottom: 10px;
        border-color: ${props =>
            props.theme.colors.monotoneMidLight} !important;
        resize: none !important;
    }

    ${"" /* terms-of-service */}
    .terms-of-service{
        height: 17rem !important;
        margin-bottom: 10px;
        border-color: ${props =>
            props.theme.colors.monotoneMidLight} !important;
        resize: none !important;
    }

    ${"" /* response-error */}
    .error-summary .error-summary-page:first-child{
        padding-top: ${remCalc(8)};
    }

    .error-summary .error-summary-page{
        padding: 0 ${remCalc(12)} ${remCalc(8)} ${remCalc(12)};
        text-align: left!important;
    }

    ${"" /* react-select */}
    .react-select__menu-list{
        .react-select__option, .react-select__group-heading{
            line-height: ${remCalc(24)};
            padding: ${remCalc(12)} ${remCalc(14)};
        }
        .react-select__group{
            padding: 0;
            .react-select__group-heading{
                margin: 0;
                color: ${props => props.theme.colors.monotoneDark};
                font-weight: ${props => props.theme.fontWeights.semiBold};
                font-size: ${props => props.theme.fontSizes[2]};
                text-transform: capitalize;
            }
            .react-select__option{
                padding: ${remCalc(12)} ${remCalc(28)};
            }
        }
    }

    ${"" /* honeypot field */}
    .honeypot{
        display: none !important;    
        position: absolute !important;    
        left: -9000px;
    }
`;

export default GlobalStyle;
